/* eslint-disable max-len */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Menu, Icon } from 'antd';
import { Link } from 'react-router-dom';
import {
  toNumber, map, remove, isNaN
} from 'lodash';
import PropTypes from 'prop-types';
import CustomScrollbars from 'util/CustomScrollbars';
import Auxiliary from 'util/Auxiliary';
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE
} from 'src/constants/ThemeSetting';
import Permission from 'src/helpers/Permission';
import IntlMessages from 'src/util/IntlMessages';
import { AuthenticationMenu } from 'src/helpers/Authorization';
import { getCookieValue } from 'src/util/Common';
import SidebarHome from './SidebarHome';
import SidebarLogo from './SidebarLogo';

const { SubMenu } = Menu;
const MenuItem = Menu.Item;

class SidebarContent extends Component {
  state = {
    isCollapse: false
  }

  getNoHeaderClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
      return 'gx-no-header-notifications';
    }
    return '';
  };

  getNavStyleSubMenuClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return 'gx-no-header-submenu-popup';
    }
    return '';
  };

  changeCollapsed = (isCollapse) => {
    this.setState({ isCollapse });
  }

  /**
   * Thay đổi lại key menu để thiết lập active menu kể cả khi nhấn vào thêm mới chỉnh sửa
   * @params {*} list danh sách
   * @memberof SidebarContent
   */
  reSelectedKeys = (selectedKeys) => {
    const listToRemove = ['them-moi', 'chinh-sua', '', 'chi-tiet'];
    const selectedKeysTmp = selectedKeys.split('/');
    map(listToRemove, val => remove(selectedKeysTmp, item => item === val));
    // Remove all number as string in array
    remove(selectedKeysTmp, (item) => {
      // convert to number
      if (!isNaN(toNumber(item))) {
        return true;
      }
      return false;
    });
    return selectedKeysTmp.join('/');
  }

  render() {
    const {
      themeType, pathname, navStyle, activedVaiTro
    } = this.props;
    const selectedKeys = pathname.substr(1);
    const newSelectedKeys = this.reSelectedKeys(selectedKeys);
    const { isCollapse } = this.state;
    const type = getCookieValue('currentMenuTop') ? getCookieValue('currentMenuTop').type : '';

    /** All */
    const thongKeAll = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_ALL, Permission.XEM]);

    // Thanh tra
    const thanhTra = AuthenticationMenu(activedVaiTro, [Permission.THANH_TRA]);

    /** Quản lý thương mại */
    const phongQLTM = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.P_QLTM, Permission.XEM]);

    // Thương nhân
    // const dmThuongNhan = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_QUAN_LY_THUONG_NHAN, Permission.XEM]);
    const isThuongNhan = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.THUONG_NHAN, Permission.XEM]);
    // Xăng dầu
    const qlXangDau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_XANG_DAU, Permission.XEM]);
    const dmCoQuanChuQuan = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_CO_QUAN_CHU_QUAN, Permission.XEM]);
    const dmDaiLyXangDau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_DAI_LY_XD, Permission.XEM]);
    const bcCuaHangXangDau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_CUA_HANG_XANG_DAU, Permission.XEM]);

    // Thuốc lá
    const qlThuocLa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_THUOC_LA, Permission.XEM]);
    const dmNhaBanBuon = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_NHA_BAN_BUON, Permission.XEM]);
    const bcBanBuonThuocLa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_BAN_BUON_THUOC_LA, Permission.XEM]);
    const tkTinhHinhKinhDoanhThuocLa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_THUOC_LA, Permission.XEM]);

    // VSATTP
    const qlVSATTP = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_VSATTP, Permission.XEM]);
    const dmNganhNgheKD = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_NGANH_NGHE_KD, Permission.XEM]);
    const dmDanhSachCSVSATTP = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_CO_SO_VSATTP, Permission.XEM]);
    const bcVSATTTP = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_ATTP, Permission.XEM]);
    const tkTongHopCSVSATTP = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_TONG_HOP_CSVS_ATTP, Permission.XEM]);
    const tkCSVSATTP = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_CSVSATTP, Permission.XEM]);
    // Rượu
    const qlRuou = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_RUOU, Permission.XEM]);
    const dmChungLoaiRuou = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_CHUNG_LOAI_RUOU, Permission.XEM]);
    const bcRuouTC = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_RUOU_TC, Permission.XEM]);
    const bcRuouCN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_RUOU_CONG_NGHIEP, Permission.XEM]);
    // Chợ
    const qlCho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_CHO, Permission.XEM]);
    const bcCho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_CHO, Permission.XEM]);
    const tkPhatTrienCho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_PHAT_TRIEN_CHO, Permission.XEM]);
    // Gas
    const qlGas = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_GAS, Permission.XEM]);
    const bcGas = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_GAS, Permission.XEM]);
    const tkCuaHangGas = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_CUA_HANG_GAS, Permission.XEM]);
    // Doanh nghiep đa cấp
    const qlDoanhNghiepDaCap = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_DNBH_DA_CAP, Permission.XEM]);
    const bcDoanhNghiepDaCap = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_DOANH_NGHIEP_DA_CAP, Permission.XEM]);
    const tkDoanhNghiepDaCap = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_DOANH_NGHIEP_DA_CAP, Permission.XEM]);
    // Hội chợ
    const qlHoiCho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_HOI_CHO, Permission.XEM]);
    const bcHoiCho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_HOI_CHO, Permission.XEM]);
    const tkHoiCho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_HOI_CHO, Permission.XEM]);
    // Hợp đông theo mẫu
    const qlHopDongTheoMau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_HOP_DONG_THEO_MAU, Permission.XEM]);
    const bcHopDongTheoMau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_HOP_DONG_THEO_MAU, Permission.XEM]);
    const tkHopDongTheoMau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_DOANH_NGHIEP_DANG_KY_HOP_DONG_THUONG_MAI, Permission.XEM]);
    // Quản lý đăng ký dấu
    const qlDangKyDau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_DANG_KY_DAU, Permission.XEM]);
    const bcDangKyDau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_DANG_KY_DAU, Permission.XEM]);
    const tkDangKyDau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_DANG_KY_DAU, Permission.XEM]);
    // Quản lý đăng ký khuyến mại
    const qlDangKyKhuyenMai = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_DANG_KY_KHUYEN_MAI, Permission.XEM]);
    const bcDangKyKhuyenMai = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_DANG_KY_KHUYEN_MAI, Permission.XEM]);
    // Quản lý Biểu mẫu khác
    const qlBieuMauKhac = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_BIEU_MAU_KHAC, Permission.XEM]);
    const bcTongMucBanLeHangHoa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TONG_MUC_BAN_LE_HANG_HOA, Permission.XEM]);
    const bcTieuChiCshttmNongThon = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TIEU_CHI_CSHTTM_NONG_THON, Permission.XEM]);

    // Phòng quản lý công nghiệp
    const phongQLCN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.P_QLCN, Permission.XEM]);
    const tkKhuCongNghiep = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_KHU_CONG_NGHIEP, Permission.XEM]);
    const qlCumCNDA = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_CUM_CN_DA, Permission.XEM]);
    const dmCumCN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_CUM_CONG_NGHIEP, Permission.XEM]);
    const dmCoSoHaTang = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_CO_SO_HA_TANG_THDT, Permission.XEM]);
    const dmDuAn = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_DU_AN, Permission.XEM]);
    const bcCCN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_CUM_CONG_NGHIEP, Permission.XEM]);
    const bcDuAn = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_DU_AN, Permission.XEM]);
    const tkThdtKcht = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_THDT_KCHT, Permission.XEM]);
    const tkDuAn = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_DU_AN, Permission.XEM]);
    const qlKCN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_KHU_CN, Permission.XEM]);
    const dmQLKCN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_KHU_CONG_NGHIEP, Permission.XEM]);
    const dmKcn = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_KCN, Permission.XEM]);
    const bcKCN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_KHU_CONG_NGHIEP, Permission.XEM]);
    const dmDuAnDauTu = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_DU_AN_DAU_TU, Permission.XEM]);
    // const thuongNhan = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.THUONG_NHAN, Permission.XEM]);

    // Quản lý thương mại điện tử
    const qlTmdt = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_TMDT, Permission.XEM]);
    const bcTmdt = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_THUONG_MAI_DIEN_TU, Permission.XEM]);
    const tkTmdt = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_TMDT, Permission.XEM]);
    // Quản lý khuyến công
    const qlKhuyenCong = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_KHUYEN_CONG, Permission.XEM]);
    const bcKhuyenCong = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_KHUYEN_CONG, Permission.XEM]);
    const bcKhuyenCongDP = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.KHUYEN_CONG_DIA_PHUONG, Permission.XEM]);
    const bcKhuyenCongUT = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.KHUYEN_CONG_UOC_TINH, Permission.XEM]);
    const bcKqHoTro = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_KET_QUA_HO_TRO, Permission.XEM]);
    const bcUocTinhThucHien = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_UOC_TINH_THUC_HIEN, Permission.XEM]);
    // Sản phẩm công nghiệp
    const qlSanPhamCn = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_SAN_PHAM_CN, Permission.XEM]);
    const bcMotSoSpcnChuYeu = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_MOT_SO_SPCN_CHU_YEU, Permission.XEM]);
    const bcChiSoSanXuatCn = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_CHI_SO_SAN_XUAT_CN, Permission.XEM]);
    const bcKqBinhChonSpcnTieuBieu = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_KQ_BINH_CHON_SPCN_TIEU_BIEU, Permission.XEM]);

    // CSDL Lĩnh vực khoáng sản
    const qlLinhVucKhoangSan = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_LINH_VUC_KHOANG_SAN, Permission.XEM]);
    const dmLinhVucKhoangSan = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_LINH_VUC_KHOANG_SAN, Permission.XEM]);


    /** Kỹ thuật ATMT */
    const phongKTATMT = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.P_KTATMT, Permission.XEM]);
    // Vật liệu nổ
    const qlVLN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_VLN, Permission.XEM]);
    const dmDoanhNghiep = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_QUAN_LY_DOANH_NGHIEP, Permission.XEM]);
    const dmLoaiHinhHD = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_LOAI_HINH_HD, Permission.XEM]);
    const bcVLN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_VLN, Permission.XEM]);
    const tkCapPhepVLN = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_GIAY_PHEP_VLNCN, Permission.XEM]);
    // Hóa chất
    const qlHoaChat = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_HOA_CHAT, Permission.XEM]);
    const dmCoSoSuDungHoaChat = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_CO_SO_SU_DUNG_HOA_CHAT, Permission.XEM]);
    const bcLoaiHC = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.LOAI_HOA_CHAT, Permission.XEM]);
    const bcSuCoHC = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TINH_HINH_SU_CO_HOA_CHAT, Permission.XEM]);
    const bcThanhTraHC = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_THANH_TRA_HC, Permission.XEM]);
    const tkLoaiHC = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_LOAI_HOA_CHAT, Permission.XEM]);
    const tkSuCoHC = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_TINH_HINH_SU_CO_HOA_CHAT, Permission.XEM]);
    const tkThanhTraHC = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_THANH_TRA_HC, Permission.XEM]);
    // công bố hợp quy
    // Theo dõi công bố hợp quy
    const qlCongBoHopQuy = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_CONG_BO_HOP_QUY, Permission.XEM]);
    const dmTheoDoiCongBoHopQuy = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_THEO_DOI_CONG_BO_HOP_QUY, Permission.XEM]);
    const dmDoanhNghiepCongBoHopQuy = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_THEO_DOI_CONG_BO_HOP_QUY, Permission.XEM]);

    /** Quản lý năng lượng */
    const phongQLNL = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.P_QLNL, Permission.XEM]);
    const qlThuyDien = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_THUY_DIEN, Permission.XEM]);
    const dmThuyDien = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_THUY_DIEN, Permission.XEM]);
    const bcThuyDien = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_THUY_DIEN, Permission.XEM]);
    const qlTramBa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_TRAM_BA, Permission.XEM]);
    const dmTba = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_TBA, Permission.XEM]);
    const dmTba110 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_TBA110, Permission.XEM]);
    const dmTba220 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_TBA220, Permission.XEM]);
    const dmTba500 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_TBA500, Permission.XEM]);
    const qlCapDien = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_CAP_DIEN, Permission.XEM]);
    const bcCapDien = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_CAP_DIEN, Permission.XEM]);
    const tkCapDien = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.TK_CAP_DIEN, Permission.XEM]);
    const qlQuyTrinhVanHanh = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_QUY_TRINH_VAN_HANH, Permission.XEM]);
    const khSuDungNlTrongDiem = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.KH_SU_DUNG_NL_TRONG_DIEM, Permission.XEM]);
    const dmKhSuDungNlTrongDiem = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_KH_SU_DUNG_NL_TRONG_DIEM, Permission.XEM]);

    const qlNLTaiTaoVaNLKhac = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_NL_TAI_TAO_VA_NANG_LUONG_KHAC, Permission.XEM]);
    const dmDuAnNLTaiTaoVaNLKhac = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_DU_AN_NL_TAI_TAO_VA_NANG_LUONG_KHAC, Permission.XEM]);

    const qlCapPhepHoatDongDienLuc = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_CAP_PHEP_HOAT_DONG_DIEN_LUC, Permission.XEM]);
    const dmCapPhepHoatDongDienLuc = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_CAP_PHEP_HOAT_DONG_DIEN_LUC, Permission.XEM]);

    // Thuốc lá 2020
    const qlThuocLa2020 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_THUOC_LA_2020, Permission.XEM]);
    const dmThuocLa2020 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_THUOC_LA_2020, Permission.XEM]);
    const dmQuanLyThuongNhanThuocLa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_QUAN_LY_THUONG_NHAN_THUOC_LA, Permission.XEM]);
    const bcThuocLa2020 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_THUOC_LA_2020, Permission.XEM]);
    const bcThuongNhanBanLe = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_THUONG_NHAN_BAN_LE, Permission.XEM]);
    const bcThuongNhanDuocCapPhep = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_THUONG_NHAN_DUOC_CAP_PHEP, Permission.XEM]);
    const bcTinhHinhKinhDoanh = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TINH_HINH_KINH_DOANH, Permission.XEM]);
    const bcDauTuTrongCayThuocLa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_DAU_TU_TRONG_CAY_THUOC_LA, Permission.XEM]);
    const bcThuongNhanBanBuon = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_THUONG_NHAN_BAN_BUON, Permission.XEM]);
    const bcPhanPhoiSanPhamThuocLa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_PHAN_PHOI_SAN_PHAM_THUOC_LA, Permission.XEM]);
    const bcBanHangTaiCacTinhThanhPho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_BAN_HANG_TAI_CAC_TINH_THANH_PHO, Permission.XEM]);
    const bcBanHangTaiCacDiemBanLe = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_BAN_HANG_TAI_CAC_DIEM_BAN_LE, Permission.XEM]);
    const bcTrongCayThuocLa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TRONG_CAY_THUOC_LA, Permission.XEM]);

    // Rượu 2020
    const qlRuou2020 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_RUOU_2020, Permission.XEM]);
    const dmRuou2020 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_RUOU_2020, Permission.XEM]);
    const dmQuanLyThuongNhanRuou = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.DM_QUAN_LY_THUONG_NHAN_RUOU, Permission.XEM]);
    const bcRuou2020 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_RUOU_2020, Permission.XEM]);
    const bcTinhHinhSanXuatRuou = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TINH_HINH_SAN_XUAT_RUOU, Permission.XEM]);
    const bcTinhHinhSanXuat = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TINH_HINH_SAN_XUAT, Permission.XEM]);
    const bcTinhHinhTieuThu = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TINH_HINH_TIEU_THU, Permission.XEM]);
    const bcPhanPhoiRuouBanBuon = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_PHAN_PHOI_RUOU_BAN_BUON, Permission.XEM]);
    const bcTinhHinhMuaVao = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TINH_HINH_MUA_VAO, Permission.XEM]);
    const bcTinhHinhBanRa = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TINH_HINH_BAN_RA, Permission.XEM]);
    // const bcBanLeRuouTieuDungTaiCho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_BAN_LE_RUOU_TIEU_DUNG_TAI_CHO, Permission.XEM]);
    // const bcRuouThuCong = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_RUOU_THU_CONG, Permission.XEM]);
    const bcSanXuatRuouBanChoDoanhNghiep = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_SAN_XUAT_RUOU_BAN_CHO_DOANH_NGHIEP, Permission.XEM]);
    const bcSanXuatRuouKinhDoanh = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_SAN_XUAT_RUOU_KINH_DOANH, Permission.XEM]);
    const bcBanLeRuou = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_BAN_LE_RUOU, Permission.XEM]);
    const bcBanRuouTieuDungTaiCho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_BAN_RUOU_TIEU_DUNG_TAI_CHO, Permission.XEM]);
    // const bcRuouTieuDungTaiCho = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_RUOU_TIEU_DUNG_TAI_CHO, Permission.XEM]);
    const bcSanXuatRuouCongNghiep = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_SAN_XUAT_RUOU_CONG_NGHIEP, Permission.XEM]);
    const bcSanXuatRuou = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_SAN_XUAT_RUOU, Permission.XEM]);
    const bcTinhHinhKinhDoanhRuou = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_TINH_HINH_KINH_DOANH_RUOU, Permission.XEM]);
    const bcRuouCoDoConDuoi55 = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_RUOU_CO_DO_CON_DUOI_5_5, Permission.XEM]);

    /** Quản lý thị trường */
    const pQltt = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.P_QLTT, Permission.XEM]);
    const qlThiTruong = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_THI_TRUONG, Permission.XEM]);
    const bcCtqlThiTruong = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_CTQL_THI_TRUONG, Permission.XEM]);

    /** Quản lý đầu tư */
    const pQldt = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.P_QLDT, Permission.XEM]);
    const qlXuatNhapKhau = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.QL_XUAT_NHAP_KHAU, Permission.XEM]);
    const bcKimNgachXnk = AuthenticationMenu(activedVaiTro, [Permission.ADMIN, Permission.BC_KIM_NGACH_XNK, Permission.XEM]);

    return (
      <Auxiliary>
        <SidebarLogo changeCollapsed={this.changeCollapsed} />
        <div className="gx-sidebar-content">
          <CustomScrollbars className="gx-layout-sider-scrollbar">
            {
              !type && !isCollapse && <SidebarHome />
            }
            {/* QUẢN LÝ THƯƠNG MẠI */}
            {
              type === Permission.P_QLTM
              && (
                thongKeAll
                || phongQLTM
                || qlXangDau || dmCoQuanChuQuan || dmDaiLyXangDau || bcCuaHangXangDau
                || qlThuocLa || dmNhaBanBuon || bcBanBuonThuocLa || tkTinhHinhKinhDoanhThuocLa
                || qlVSATTP || dmNganhNgheKD || dmDanhSachCSVSATTP || bcVSATTTP || tkTongHopCSVSATTP || tkCSVSATTP
                || qlRuou || dmChungLoaiRuou || bcRuouTC || bcRuouCN
                || qlCho || bcCho || tkPhatTrienCho
                || qlTmdt || bcTmdt || tkTmdt
                || qlGas || bcGas || tkCuaHangGas
                || qlDoanhNghiepDaCap || bcDoanhNghiepDaCap || tkDoanhNghiepDaCap
                || qlHoiCho || bcHoiCho || tkHoiCho
                || qlHopDongTheoMau || bcHopDongTheoMau || tkHopDongTheoMau
                || qlDangKyDau || bcDangKyDau || tkDangKyDau
                || isThuongNhan
                || qlThuocLa2020 || dmThuocLa2020 || dmQuanLyThuongNhanThuocLa || bcThuocLa2020 || bcThuongNhanBanLe || bcThuongNhanDuocCapPhep || bcTinhHinhKinhDoanh || bcDauTuTrongCayThuocLa || bcThuongNhanBanBuon || bcPhanPhoiSanPhamThuocLa || bcBanHangTaiCacTinhThanhPho || bcBanHangTaiCacDiemBanLe || bcTrongCayThuocLa
                || qlRuou2020 || dmRuou2020 || dmQuanLyThuongNhanRuou || bcRuou2020 || bcSanXuatRuou || bcTinhHinhSanXuatRuou || bcSanXuatRuouCongNghiep || bcTinhHinhSanXuat || bcTinhHinhTieuThu || bcSanXuatRuouKinhDoanh || bcSanXuatRuouBanChoDoanhNghiep || bcTinhHinhKinhDoanhRuou || bcPhanPhoiRuouBanBuon || bcTinhHinhMuaVao || bcTinhHinhBanRa || bcBanLeRuou || bcBanRuouTieuDungTaiCho || bcRuouCoDoConDuoi55
                || qlDangKyKhuyenMai || bcDangKyKhuyenMai
                || qlBieuMauKhac || bcTongMucBanLeHangHoa || bcTieuChiCshttmNongThon
                || thanhTra
              )
              && (
                <Menu
                  className="submenu-parent"
                  defaultOpenKeys={!isCollapse ? ['hoi-cho', 'xang-dau', 'thuoc-la', 've-sinh-attp', 'ruou', 'cho', 'gas', 'doanh-nghiep', 'thuong-mai-dien-tu', 'hop-dong-theo-mau', 'dang-ky-dau', 'thuoc-la-2020', 'ruou-2020', 'quan-ly-dang-ky-khuyen-mai', 'quan-ly-bieu-mau-khac'] : []}
                  mode="inline"
                  selectedKeys={[newSelectedKeys]}
                  theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
                >
                  {/** Xăng dầu */}
                  {(phongQLTM || qlXangDau || dmCoQuanChuQuan || dmDaiLyXangDau || bcCuaHangXangDau || thanhTra)
                    && (
                      <SubMenu
                        key="xang-dau"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Xăng dầu' : null}>{isCollapse && <i className="icon fas fa-gas-pump" />}<IntlMessages id="sidebar.xangDau" /></span>}
                      >
                        {(phongQLTM || qlXangDau || dmCoQuanChuQuan || dmDaiLyXangDau || thanhTra)
                          && (
                            <SubMenu
                              key="danh-muc/xang-dau"
                              title={<span title="Danh mục xăng dầu">Danh mục</span>}
                            >
                              {(phongQLTM || qlXangDau || dmCoQuanChuQuan)
                                && (
                                  <Menu.Item key="danh-muc/xang-dau/co-quan-chu-quan">
                                    <Link
                                      title="Danh mục cơ quan chủ quản"
                                      to="/danh-muc/xang-dau/co-quan-chu-quan"
                                    >Cơ quan chủ quản
                                    </Link>
                                  </Menu.Item>
                                )
                              }
                              {(phongQLTM || qlXangDau || dmDaiLyXangDau || thanhTra)
                                && (
                                  <Menu.Item key="danh-muc/xang-dau/dai-ly-xang-dau">
                                    <Link
                                      title="Danh mục thương nhân cung cấp xăng dầu"
                                      to="/danh-muc/xang-dau/dai-ly-xang-dau"
                                    >Thương nhân cung cấp xăng dầu
                                    </Link>
                                  </Menu.Item>
                                )
                              }
                            </SubMenu>
                          )
                        }
                        {(phongQLTM || qlXangDau || bcCuaHangXangDau || thanhTra)
                          && (
                            <SubMenu key="bao-cao/xang-dau" title={<span title="Báo cáo xăng dầu">Báo cáo</span>}>
                              {(phongQLTM || qlXangDau || bcCuaHangXangDau || thanhTra)
                                && (
                                  <Menu.Item key="danh-muc/xang-dau/cua-hang-xang-dau">
                                    <Link
                                      title="Báo cáo cửa hàng xăng dầu"
                                      to="/danh-muc/xang-dau/cua-hang-xang-dau"
                                    >Cửa hàng xăng dầu
                                    </Link>
                                  </Menu.Item>
                                )
                              }
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                  {/** Thuốc lá */}
                  {/* {(thongKeAll || phongQLTM || qlThuocLa || dmNhaBanBuon || dmQuanLyThuongNhanThuocLa || bcBanBuonThuocLa || tkTinhHinhKinhDoanhThuocLa) &&
                  <SubMenu key="thuoc-la"
                    title={<span className="wrap-icon-sidebar" title={isCollapse ? "Thuốc lá" : ""}>{isCollapse && <i className="icon fas fa-smoking" />}<IntlMessages id="sidebar.thuocLa" /></span>}
                    className={this.getNavStyleSubMenuClass(navStyle)}>
                    {(phongQLTM || qlThuocLa || dmNhaBanBuon || dmQuanLyThuongNhanThuocLa) &&
                      <SubMenu key="danh-muc/thuoc-la" title={<span>Danh mục</span>}>
                        {(phongQLTM || qlThuocLa || dmNhaBanBuon) &&
                          <MenuItem key="danh-muc/thuoc-la/nha-ban-buon">
                            <Link to="/danh-muc/thuoc-la/nha-ban-buon">Nhà bán buôn</Link>
                          </MenuItem>
                        }
                        {(phongQLTM || qlThuocLa || dmQuanLyThuongNhanThuocLa) &&
                          <MenuItem key="/danh-muc/quan-ly-thuong-nhan/thuong-nhan">
                            <Link
                              to={{
                                pathname: "/danh-muc/quan-ly-thuong-nhan/thuong-nhan",
                                state: {
                                  isRuou: false,
                                  isThuocLa: true
                                }
                              }}
                            >Quản lý thương nhân</Link>
                          </MenuItem>
                        }
                      </SubMenu>
                    }
                    {(phongQLTM || qlThuocLa || bcBanBuonThuocLa) &&
                      <SubMenu key="bao-cao/thuoc-la" title={<span>Báo cáo</span>}>
                        {(phongQLTM || qlThuocLa || bcBanBuonThuocLa) &&
                          <MenuItem key="bao-cao/thuoc-la/bao-cao-ban-buon-thuoc-la">
                            <Link to="/bao-cao/thuoc-la/bao-cao-ban-buon-thuoc-la">Báo cáo bán buôn thuốc lá</Link>
                          </MenuItem>
                        }
                      </SubMenu>
                    }
                    {(thongKeAll || phongQLTM || qlThuocLa || tkTinhHinhKinhDoanhThuocLa) &&
                      <SubMenu key="thong-ke/tinh-hinh-kinh-doanh-ban-le" title={<span>Thống kê</span>}>
                        {(thongKeAll || phongQLTM || qlThuocLa || tkTinhHinhKinhDoanhThuocLa) &&
                          <MenuItem key="thong-ke/tinh-hinh-kinh-doanh-ban-le">
                            <Link to="/thong-ke/tinh-hinh-kinh-doanh-ban-le">Tình hình kinh doanh thuốc lá</Link>
                          </MenuItem>
                        }
                      </SubMenu>
                    }
                  </SubMenu>
                } */}
                  {/** Vệ sinh ATTP */}
                  {(thongKeAll || phongQLTM || qlVSATTP || dmNganhNgheKD || dmDanhSachCSVSATTP || bcVSATTTP || tkTongHopCSVSATTP || tkCSVSATTP)
                    && (
                      <SubMenu
                        key="ve-sinh-attp"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Vệ sinh ATTP' : ''}>{isCollapse && <i className=" icon fas fa-shopping-basket" />}<IntlMessages id="sidebar.veSinhATTP" /></span>}
                      >
                        {(phongQLTM || qlVSATTP || dmNganhNgheKD || dmDanhSachCSVSATTP)
                          && (
                            <SubMenu key="danh-muc/ve-sinh-attp" title={<span title="Danh mục vệ sinh ATTP">Danh mục</span>}>
                              {(phongQLTM || qlVSATTP || dmNganhNgheKD)
                                && (
                                  <MenuItem key="danh-muc/ve-sinh-attp/nganh-nghe-kinh-doanh">
                                    <Link
                                      title="Danh mục ngành nghề kinh doanh"
                                      to="/danh-muc/ve-sinh-attp/nganh-nghe-kinh-doanh"
                                    >Ngành nghề kinh doanh
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(phongQLTM || qlVSATTP || dmDanhSachCSVSATTP)
                                && (
                                  <MenuItem key="danh-muc/ve-sinh-attp/co-so-vsattp">
                                    <Link
                                      title="Danh mục danh sách cơ sở VSATTP"
                                      to="/danh-muc/ve-sinh-attp/co-so-vsattp"
                                    >Danh sách cơ sở VSATTP
                                    </Link>
                                  </MenuItem>
                                )
                              }
                            </SubMenu>
                          )
                        }
                        {(phongQLTM || qlVSATTP || bcVSATTTP)
                          && (
                            <SubMenu key="bao-cao/ve-sinh-attp" title={<span title="Báo cáo VSATTP (Huyện bc)">Báo cáo</span>}>
                              <MenuItem key="bao-cao/ve-sinh-attp/bao-cao-ve-sinh-attp">
                                <Link
                                  title="Báo cáo cơ sở VSATTP (Huyện bc)"
                                  to="/bao-cao/ve-sinh-attp/bao-cao-ve-sinh-attp"
                                >Báo cáo cơ sở VSATTP
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                        {(thongKeAll || phongQLTM || qlVSATTP || tkTongHopCSVSATTP || tkCSVSATTP)
                          && (
                            <SubMenu key="thong-ke/ve-sinh-attp" title={<span title="Thống kê VSATTP">Thống kê</span>}>
                              {(thongKeAll || phongQLTM || qlVSATTP || tkCSVSATTP)
                                && (
                                  <MenuItem key="thong-ke/ve-sinh-attp">
                                    <Link
                                      title="Thống kê cơ sở VSATTP"
                                      to="/thong-ke/ve-sinh-attp"
                                    >Cơ sở VSATTP
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(thongKeAll || phongQLTM || qlVSATTP || tkTongHopCSVSATTP)
                                && (
                                  <MenuItem key="thong-ke/tong-hop-cssxkd">
                                    <Link
                                      title="Thống kê tổng hợp CSVS-ATTP"
                                      to="/thong-ke/tong-hop-cssxkd"
                                    >Tổng hợp CSVS-ATTP
                                    </Link>
                                  </MenuItem>
                                )
                              }
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }

                  {/** Rượu */}
                  {/* {(phongQLTM || qlRuou || dmChungLoaiRuou || bcRuouTC || bcRuouCN || dmQuanLyThuongNhanThuocLa || isThuongNhan) &&
                  <SubMenu key="ruou"
                    title={<span className="wrap-icon-sidebar" title={isCollapse ? "Rượu" : ''}>{isCollapse && <i className="icon fas fa-wine-glass" />}<IntlMessages id="sidebar.ruou" /></span>}
                    className={this.getNavStyleSubMenuClass(navStyle)}>
                    {(phongQLTM || qlRuou || dmChungLoaiRuou || dmQuanLyThuongNhanThuocLa) &&
                      <SubMenu key="danh-muc/ruou" title={<span>Danh mục</span>}>
                        {(phongQLTM || qlRuou || dmChungLoaiRuou) &&
                          <MenuItem key="danh-muc/ruou/chung-loai-ruou">
                            <Link to="/danh-muc/ruou/chung-loai-ruou">Chủng loại rượu</Link>
                          </MenuItem>
                        }
                        {(phongQLTM || qlRuou || dmQuanLyThuongNhanThuocLa) &&
                          <MenuItem key="/danh-muc/quan-ly-thuong-nhan/thuong-nhan">
                            <Link to={{
                              pathname: "/danh-muc/quan-ly-thuong-nhan/thuong-nhan",
                              state: {
                                isRuou: true,
                                isThuocLa: false
                              }
                            }}>Quản lý thương nhân</Link>
                          </MenuItem>
                        }
                      </SubMenu>
                    }
                    {(phongQLTM || qlRuou || bcRuouTC || bcRuouCN || isThuongNhan) &&
                      <SubMenu key="/bao-cao/ruou" title={<span>Báo cáo</span>}>
                        {(phongQLTM || qlRuou || bcRuouTC) &&
                          <MenuItem key="bao-cao/ruou/bao-cao-ruou">
                            <Link to="/bao-cao/ruou/bao-cao-ruou">Báo cáo rượu thủ công</Link>
                          </MenuItem>
                        }
                        {(phongQLTM || thuongNhan || qlRuou || bcRuouCN) &&
                          <MenuItem key="bao-cao/ruou/ruou-cong-nghiep">
                            <Link to="/bao-cao/ruou/ruou-cong-nghiep">Báo cáo rượu công nghiệp</Link>
                          </MenuItem>
                        }
                        {/* {(phongQLTM || baoCaoRuou || baoCaoSXKDRuou) &&
                          <MenuItem key="bao-cao/ruou/bao-cao-sx-kd-ruou">
                            <Link to="/bao-cao/ruou/bao-cao-sx-kd-ruou">Báo cáo SX-KD rượu</Link>
                          </MenuItem>
                        } */}
                  {/* </SubMenu>
                    }
                  </SubMenu> */}

                  {/** Thuốc lá 2020 */}
                  {(phongQLTM || qlThuocLa2020
                    || dmThuocLa2020 || dmQuanLyThuongNhanThuocLa
                    || bcThuocLa2020 || bcThuongNhanBanLe || bcDauTuTrongCayThuocLa || bcThuongNhanBanBuon || bcThuongNhanDuocCapPhep || bcTinhHinhKinhDoanh || bcPhanPhoiSanPhamThuocLa || bcBanHangTaiCacDiemBanLe || bcBanHangTaiCacTinhThanhPho || bcTrongCayThuocLa
                    || thanhTra
                  )
                    && (
                      <SubMenu
                        key="thuoc-la-2020"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Thuốc lá 2020' : ''}>{isCollapse && <i className="icon fas fa-smoking" />}<IntlMessages id="sidebar.thuocla2020" /></span>}
                      >
                        {(phongQLTM || qlThuocLa2020 || dmThuocLa2020 || dmQuanLyThuongNhanThuocLa || thanhTra)
                          && (
                            <SubMenu key="danh-muc/thuoc-la" title={<span title="Danh mục thuốc lá">Danh mục</span>}>
                              {(phongQLTM || qlThuocLa2020 || dmThuocLa2020 || dmQuanLyThuongNhanThuocLa || thanhTra)
                                && (
                                  <MenuItem key="/danh-muc/quan-ly-thuong-nhan/thuong-nhan-thuoc-la">
                                    <Link
                                      title="Danh mục quản lý thương nhân thuốc lá"
                                      to={{
                                        pathname: '/danh-muc/quan-ly-thuong-nhan/thuong-nhan-thuoc-la',
                                        state: {
                                          isRuou: false,
                                          isThuocLa: true
                                        }
                                      }}
                                    >Quản lý thương nhân thuốc lá
                                    </Link>
                                  </MenuItem>
                                )
                              }
                            </SubMenu>
                          )
                        }
                        {(phongQLTM || qlThuocLa2020 || bcThuocLa2020 || bcThuongNhanBanLe || bcDauTuTrongCayThuocLa || bcThuongNhanBanBuon || bcThuongNhanDuocCapPhep || bcTinhHinhKinhDoanh || bcPhanPhoiSanPhamThuocLa || bcBanHangTaiCacDiemBanLe || bcBanHangTaiCacTinhThanhPho || bcTrongCayThuocLa)
                          && (
                            <SubMenu key="bao-cao/thuoc-la" title={<span title="Báo cáo thuốc lá">Báo cáo</span>}>
                              {(phongQLTM || qlThuocLa2020 || bcThuocLa2020 || bcThuongNhanBanLe || bcThuongNhanDuocCapPhep || bcTinhHinhKinhDoanh)
                                && (
                                  <SubMenu
                                    key="bao-cao/thuoc-la/thuong-nhan-ban-le"
                                    style={{ marginLeft: '15px' }}
                                    title={(
                                      <span title="Báo cáo tình hình kinh doanh bán lẻ sản phẩm thuốc lá của các thương nhân trên địa bàn quận, huyện (Huyện bc)">
                                        Thương nhân bán lẻ
                                      </span>
                                    )}
                                  >
                                    {(phongQLTM || qlThuocLa2020 || bcThuocLa2020 || bcThuongNhanBanLe || bcThuongNhanDuocCapPhep)
                                      && (
                                        <MenuItem key="bao-cao/thuoc-la/bao-cao-thuong-nhan-ban-le">
                                          <Link
                                            title="Danh sách thương nhân được cấp giấy phép bán lẻ sản phẩm thuốc lá (Huyện bc)"
                                            to="/bao-cao/thuoc-la/bao-cao-thuong-nhan-ban-le"
                                          >
                                            <Icon type="reconciliation" />Thương nhân được cấp phép
                                          </Link>
                                        </MenuItem>
                                      )
                                    }
                                    {(phongQLTM || qlThuocLa2020 || bcThuocLa2020 || bcThuongNhanBanLe || bcTinhHinhKinhDoanh)
                                      && (
                                        <MenuItem key="bao-cao/thuoc-la/tinh-hinh-kinh-doanh">
                                          <Link
                                            title="Tình hình kinh doanh của thương nhân bán lẻ sản phẩm thuốc lá (Huyện bc)"
                                            to="/bao-cao/thuoc-la/tinh-hinh-kinh-doanh"
                                          >
                                            <Icon type="reconciliation" />Tình hình kinh doanh
                                          </Link>
                                        </MenuItem>
                                      )
                                    }
                                  </SubMenu>
                                )
                              }
                              {(phongQLTM || qlThuocLa2020 || bcThuocLa2020 || bcTrongCayThuocLa || bcDauTuTrongCayThuocLa)
                                && (
                                  <SubMenu
                                    key="bao-cao/thuoc-la/trong-cay-thuoc-la"
                                    style={{ marginLeft: '15px' }}
                                    title={(
                                      <span title="Báo cáo tình hình trồng cây thuốc lá">
                                        Trồng cây thuốc lá
                                      </span>
                                    )}
                                  >
                                    {(phongQLTM || qlThuocLa2020 || bcThuocLa2020 || bcTrongCayThuocLa || bcDauTuTrongCayThuocLa)
                                      && (
                                        <MenuItem key="bao-cao/thuoc-la/dau-tu-trong-cay-thuoc-la">
                                          <Link
                                            title="Báo cáo tình hình đầu tư trồng cây thuốc lá"
                                            to="/bao-cao/thuoc-la/dau-tu-trong-cay-thuoc-la"
                                          >
                                            <Icon type="reconciliation" />Đầu tư trồng cây thuốc lá
                                          </Link>
                                        </MenuItem>
                                      )
                                    }
                                  </SubMenu>
                                )
                              }
                              {(phongQLTM || qlThuocLa2020 || bcThuocLa2020 || bcThuongNhanBanBuon || bcPhanPhoiSanPhamThuocLa || bcBanHangTaiCacTinhThanhPho || bcBanHangTaiCacDiemBanLe)
                                && (
                                  <SubMenu
                                    key="bao-cao/thuoc-la/thuong-nhan-ban-buon"
                                    style={{ marginLeft: '15px' }}
                                    title={(
                                      <span title="Báo cáo tình hình kinh doanh của thương nhân bán buôn sản phẩm thuốc lá">
                                        Thương nhân bán buôn
                                      </span>
                                    )}
                                  >
                                    {(phongQLTM || qlThuocLa2020 || bcThuocLa2020 || bcThuongNhanBanBuon || bcPhanPhoiSanPhamThuocLa)
                                      && (
                                        <MenuItem key="bao-cao/thuoc-la/phan-phoi-san-pham-thuoc-la">
                                          <Link
                                            title="Tình hình phân phối sản phẩm thuốc lá"
                                            to="/bao-cao/thuoc-la/phan-phoi-san-pham-thuoc-la"
                                          >
                                            <Icon type="reconciliation" />Phân phối sản phẩm thuốc lá
                                          </Link>
                                        </MenuItem>
                                      )
                                    }
                                    {(phongQLTM || qlThuocLa2020 || bcThuocLa2020 || bcThuongNhanBanBuon || bcBanHangTaiCacTinhThanhPho)
                                      && (
                                        <MenuItem key="bao-cao/thuoc-la/ban-hang-tai-cac-tinh-thanh-pho">
                                          <Link
                                            title="Chi tiết tình hình bán hàng tại các tỉnh, thành phố"
                                            to="/bao-cao/thuoc-la/ban-hang-tai-cac-tinh-thanh-pho"
                                          >
                                            <Icon type="reconciliation" />Bán tại các tỉnh, thành phố
                                          </Link>
                                        </MenuItem>
                                      )
                                    }
                                    {(phongQLTM || qlThuocLa2020 || bcThuocLa2020 || bcThuongNhanBanBuon || bcBanHangTaiCacDiemBanLe)
                                      && (
                                        <MenuItem key="bao-cao/thuoc-la/ban-hang-tai-cac-dia-diem-ban-le">
                                          <Link
                                            title="Chi tiết tình hình bán hàng tại các địa điểm bán lẻ"
                                            to="/bao-cao/thuoc-la/ban-hang-tai-cac-dia-diem-ban-le"
                                          >
                                            <Icon type="reconciliation" />Bán hàng tại các địa điểm bán lẻ
                                          </Link>
                                        </MenuItem>
                                      )
                                    }
                                  </SubMenu>
                                )
                              }
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                  {/** Rượu 2020 */}
                  {(phongQLTM || qlRuou2020 || dmRuou2020 || dmQuanLyThuongNhanRuou || bcRuou2020
                    || bcTinhHinhSanXuatRuou || bcSanXuatRuouCongNghiep || bcTinhHinhSanXuat || bcTinhHinhTieuThu || bcSanXuatRuouKinhDoanh || bcSanXuatRuouBanChoDoanhNghiep
                    || bcTinhHinhKinhDoanhRuou || bcPhanPhoiRuouBanBuon || bcTinhHinhMuaVao || bcTinhHinhBanRa || bcBanLeRuou || bcBanRuouTieuDungTaiCho || bcRuouCoDoConDuoi55
                    || thanhTra)
                    && (
                      <SubMenu
                        key="ruou-2020"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Rượu 2020' : ''}>{isCollapse && <i className="icon fas fa-wine-glass" />}<IntlMessages id="sidebar.ruou2020" /></span>}
                      >
                        {(phongQLTM || qlRuou2020 || dmRuou2020 || dmQuanLyThuongNhanRuou || thanhTra)
                          && (
                            <SubMenu key="danh-muc/ruou" title={<span title="Danh mục rượu">Danh mục</span>}>
                              {(phongQLTM || qlRuou2020 || dmRuou2020 || dmQuanLyThuongNhanRuou || thanhTra)
                                && (
                                  <MenuItem key="/danh-muc/quan-ly-thuong-nhan/thuong-nhan-ruou">
                                    <Link
                                      title="Danh mục quản lý thương nhân rượu"
                                      to={{
                                        pathname: '/danh-muc/quan-ly-thuong-nhan/thuong-nhan-ruou',
                                        state: {
                                          isRuou: true,
                                          isThuocLa: false
                                        }
                                      }}
                                    >Quản lý thương nhân rượu
                                    </Link>
                                  </MenuItem>
                                )
                              }
                            </SubMenu>
                          )
                        }
                        {(phongQLTM || qlRuou2020 || bcRuou2020 || bcTinhHinhSanXuatRuou || bcSanXuatRuouCongNghiep || bcTinhHinhSanXuat || bcTinhHinhTieuThu || bcSanXuatRuouKinhDoanh || bcSanXuatRuouBanChoDoanhNghiep || bcTinhHinhKinhDoanhRuou || bcPhanPhoiRuouBanBuon || bcTinhHinhMuaVao || bcTinhHinhBanRa || bcBanLeRuou || bcBanRuouTieuDungTaiCho || bcRuouCoDoConDuoi55)
                          && (
                            <SubMenu key="bao-cao/ruou-2020" title={<span title="Báo cáo rượu">Báo cáo</span>}>
                              {(phongQLTM || qlRuou2020 || bcRuou2020 || bcTinhHinhSanXuatRuou || bcSanXuatRuouCongNghiep || bcTinhHinhSanXuat || bcTinhHinhTieuThu || bcSanXuatRuouKinhDoanh || bcSanXuatRuouBanChoDoanhNghiep || thanhTra)
                                && (
                                  <SubMenu
                                    key="bao-cao/ruou-2020/tinh-hinh-san-xuat-ruou"
                                    style={{ marginLeft: '15px' }}
                                    title={(
                                      <span title="Báo cáo tình hình sản xuất rượu">
                                        Tình hình sản xuất rượu
                                      </span>
                                    )}
                                  >
                                    {(phongQLTM || qlRuou2020 || bcRuou2020 || bcTinhHinhSanXuatRuou || bcSanXuatRuouCongNghiep || bcTinhHinhSanXuat || bcTinhHinhTieuThu)
                                      && (
                                        <SubMenu
                                          key="bao-cao/ruou-2020/tinh-hinh-san-xuat-ruou-cn"
                                          style={{ marginLeft: '15px' }}
                                          title={(
                                            <span title="Sản xuất rượu công nghiệp">
                                              Sản xuất rượu công nghiệp
                                            </span>
                                          )}
                                        >
                                          {/** Mẫu 08.1 */}
                                          {(phongQLTM || qlRuou2020 || bcRuou2020 || bcTinhHinhSanXuatRuou || bcSanXuatRuouCongNghiep || bcTinhHinhSanXuat)
                                            && (
                                              <MenuItem key="bao-cao/ruou-2020/tinh-hinh-san-xuat">
                                                <Link
                                                  title="Tình hình sản xuất"
                                                  to="/bao-cao/ruou-2020/tinh-hinh-san-xuat"
                                                >
                                                  <Icon type="plus-square" />Tình hình sản xuất
                                                </Link>
                                              </MenuItem>
                                            )
                                          }
                                          {/** Mẫu 08.2 */}
                                          {(phongQLTM || qlRuou2020 || bcRuou2020 || bcTinhHinhSanXuatRuou || bcSanXuatRuouCongNghiep || bcTinhHinhTieuThu)
                                            && (
                                              <MenuItem key="bao-cao/ruou-2020/tinh-hinh-tieu-thu">
                                                <Link
                                                  title="Tình hình tiêu thụ"
                                                  to="/bao-cao/ruou-2020/tinh-hinh-tieu-thu"
                                                >
                                                  <Icon type="plus-square" />Tình hình tiêu thụ
                                                </Link>
                                              </MenuItem>
                                            )
                                          }
                                        </SubMenu>
                                      )
                                    }
                                    {/** Mẫu 11.1 */}
                                    {/* {(phongQLTM || qlRuou2020 || bcRuou2020 || bcRuouThuCong || bcSanXuatRuouBanChoDoanhNghiep) &&
                              <MenuItem key="bao-cao/ruou-2020/san-xuat-ruou-ban-cho-doanh-nghiep">
                                <Link
                                  to="/bao-cao/ruou-2020/san-xuat-ruou-ban-cho-doanh-nghiep"
                                  title="Tình hình sản xuất rượu thủ công để bán cho doanh nghiệp có giấy phép sản xuất rượu công nghiệp để chế biến lại (Huyện bc)"
                                >
                                  <Icon type="schedule" />SX rượu bán cho doanh nghiệp</Link>
                              </MenuItem>
                            } */}
                                    {/** Mẫu 11.2 */}
                                    {(phongQLTM || qlRuou2020 || bcRuou2020 || bcTinhHinhSanXuatRuou || bcSanXuatRuouKinhDoanh)
                                      && (
                                        <MenuItem key="bao-cao/ruou-2020/san-xuat-kinh-doanh">
                                          <Link
                                            title="Tình hình sản xuất rượu thủ công nhằm mục đích kinh doanh (Huyện bc)"
                                            to="/bao-cao/ruou-2020/san-xuat-kinh-doanh"
                                          >
                                            <Icon type="down" />Sản xuất rượu kinh doanh
                                          </Link>
                                        </MenuItem>
                                      )
                                    }
                                    {/** Mẫu thông tư 26 */}
                                    {(phongQLTM || qlRuou2020 || bcRuou2020 || bcTinhHinhSanXuatRuou || bcSanXuatRuouBanChoDoanhNghiep)
                                      && (
                                        <MenuItem key="bao-cao/ruou-2020/san-xuat-ruou-ban-cho-doanh-nghiep">
                                          <Link
                                            title="Sản xuất rượu thủ công có độ cồn từ 5.5 trở lên bán cho doanh nghiệp có giấy phép sản xuất rượu công nghiệp để chế biến lại (Huyện bc)"
                                            to="/bao-cao/ruou-2020/san-xuat-ruou-ban-cho-doanh-nghiep"
                                          >
                                            <Icon type="down" />SX rượu thủ công có độ cồn từ 5.5 trở lên
                                          </Link>
                                        </MenuItem>
                                      )
                                    }
                                  </SubMenu>
                                )
                              }
                              {(phongQLTM || qlRuou2020 || bcRuou2020 || bcTinhHinhKinhDoanhRuou || bcPhanPhoiRuouBanBuon || bcTinhHinhMuaVao || bcTinhHinhBanRa || bcBanLeRuou || bcBanRuouTieuDungTaiCho || bcRuouCoDoConDuoi55)
                                && (
                                  <SubMenu
                                    key="bao-cao/ruou-2020/tinh-hinh-kinh-doanh-ruou"
                                    style={{ marginLeft: '15px' }}
                                    title={(
                                      <span title="Tình hình kinh doanh rượu">
                                        Tình hình kinh doanh rượu
                                      </span>
                                    )}
                                  >
                                    {(phongQLTM || qlRuou2020 || bcRuou2020 || bcTinhHinhKinhDoanhRuou || bcPhanPhoiRuouBanBuon || bcTinhHinhMuaVao || bcTinhHinhBanRa)
                                      && (
                                        <SubMenu
                                          key="bao-cao/ruou-2020/ban-buon-ruou"
                                          style={{ marginLeft: '15px' }}
                                          title={(
                                            <span title="Bán buôn rượu">
                                              Bán buôn rượu
                                            </span>
                                          )}
                                        >
                                          {/** Mẫu 09.1 */}
                                          {(phongQLTM || qlRuou2020 || bcRuou2020 || bcTinhHinhKinhDoanhRuou || bcPhanPhoiRuouBanBuon || bcTinhHinhMuaVao)
                                            && (
                                              <MenuItem key="bao-cao/ruou-2020/tinh-hinh-mua-vao">
                                                <Link
                                                  title="Tình hình mua vào"
                                                  to="/bao-cao/ruou-2020/tinh-hinh-mua-vao"
                                                >
                                                  <Icon type="plus-square" />Tình hình mua vào
                                                </Link>
                                              </MenuItem>
                                            )
                                          }
                                          {/** Mẫu 09.2 */}
                                          {(phongQLTM || qlRuou2020 || bcRuou2020 || bcTinhHinhKinhDoanhRuou || bcPhanPhoiRuouBanBuon || bcTinhHinhBanRa)
                                            && (
                                              <MenuItem key="bao-cao/ruou-2020/tinh-hinh-ban-ra">
                                                <Link
                                                  title="Tình hình bán ra"
                                                  to="/bao-cao/ruou-2020/tinh-hinh-ban-ra"
                                                >
                                                  <Icon type="plus-square" />Tình hình bán ra
                                                </Link>
                                              </MenuItem>
                                            )
                                          }
                                        </SubMenu>
                                      )
                                    }
                                    {/** Mẫu 11.3 */}
                                    {(phongQLTM || qlRuou2020 || bcRuou2020 || bcTinhHinhKinhDoanhRuou || bcBanLeRuou)
                                      && (
                                        <MenuItem key="bao-cao/ruou-2020/ban-le-ruou">
                                          <Link
                                            title="Bán lẻ rượu có độ cồn từ 5.5 độ trở lên (Huyện bc)"
                                            to="/bao-cao/ruou-2020/ban-le-ruou"
                                          >
                                            <Icon type="down" /> Bán lẻ rượu có độ cồn từ 5.5 độ trở lên
                                          </Link>
                                        </MenuItem>
                                      )
                                    }
                                    {/** Mẫu 11.4 */}
                                    {(phongQLTM || qlRuou2020 || bcRuou2020 || bcTinhHinhKinhDoanhRuou || bcBanRuouTieuDungTaiCho)
                                      && (
                                        <MenuItem key="bao-cao/ruou-2020/ban-ruou-tieu-dung-tai-cho">
                                          <Link
                                            title="Bán lẻ rượu có độ cồn từ 5.5 độ trở lên tiêu dùng tại chỗ (Huyện bc)"
                                            to="/bao-cao/ruou-2020/ban-ruou-tieu-dung-tai-cho"
                                          >
                                            <Icon type="down" /> Bán lẻ rượu có độ cồn từ 5.5 độ trở lên tiêu dùng tại chỗ
                                          </Link>
                                        </MenuItem>
                                      )
                                    }
                                    {/** Mẫu 11.4 */}
                                    {(phongQLTM || qlRuou2020 || bcRuou2020 || bcTinhHinhKinhDoanhRuou || bcRuouCoDoConDuoi55)
                                      && (
                                        <MenuItem key="bao-cao/ruou-2020/ban-le-ruou-duoi-5.5">
                                          <Link
                                            title="Bán lẻ rượu có độ cồn dưới 5.5 (Huyện bc)"
                                            to="/bao-cao/ruou-2020/ban-le-ruou-duoi-5.5"
                                          >
                                            <Icon type="down" /> Bán lẻ rượu có độ cồn dưới 5.5 độ
                                          </Link>
                                        </MenuItem>
                                      )
                                    }
                                    {/** Mẫu 09-II */}
                                    {/* {(phongQLTM || qlRuou2020 || bcRuou2020 || bcRuouTieuDungTaiCho || bcBanLeRuouTieuDungTaiCho) &&
                              <SubMenu style={{ marginLeft: '15px' }}
                                key="bao-cao/ruou-2020/ruou-tieu-dung-tai-cho"
                                title={<span title='Báo cáo rượu tiêu dùng tại chỗ'>
                                  Rượu tiêu dùng tại chỗ
                              </span>}
                              >
                                {(phongQLTM || qlRuou2020 || bcRuou2020 || bcRuouTieuDungTaiCho || bcBanLeRuouTieuDungTaiCho) &&
                                  <MenuItem key="bao-cao/ruou-2020/ban-le-ruou-tieu-dung-tai-cho">
                                    <Link
                                      to="/bao-cao/ruou-2020/ban-le-ruou-tieu-dung-tai-cho"
                                      title="Đối với hoạt động bán lẻ rượu/bán rượu tiêu dùng tại chỗ"
                                    >
                                      <Icon type="schedule" />Bán lẻ rượu tiêu dùng tại chỗ</Link>
                                  </MenuItem>
                                }
                              </SubMenu>
                            } */}
                                  </SubMenu>
                                )
                              }
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                  {/** Chợ */}
                  {(thongKeAll || phongQLTM || qlCho || bcCho || tkPhatTrienCho)
                    && (
                      <SubMenu
                        key="cho"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Chợ' : ''}>{isCollapse && <i className="icon fas fa-store" />}<IntlMessages id="sidebar.cho" /></span>}
                      >
                        {(phongQLTM || qlCho || bcCho)
                          && (
                            <SubMenu key="bao-cao/cho" title={<span title="Báo cáo chợ">Báo cáo</span>}>
                              <MenuItem key="bao-cao/cho/quan-ly-cho">
                                <Link
                                  title="Báo cáo quản lý chợ"
                                  to="/bao-cao/cho/quan-ly-cho"
                                >Quản lý chợ
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                        {(thongKeAll || phongQLTM || qlCho || tkPhatTrienCho)
                          && (
                            <SubMenu key="thong-ke/cho" title={<span title="Thống kê chợ">Thống kê</span>}>
                              <MenuItem key="thong-ke/phat-trien-cho">
                                <Link
                                  title="Thống kê phát triển chợ"
                                  to="/thong-ke/phat-trien-cho"
                                >Phát triển chợ
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                  {/** Hội chợ */}
                  {(thongKeAll || phongQLTM || qlHoiCho || bcHoiCho || tkHoiCho)
                    && (
                      <SubMenu
                        key="hoi-cho"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Hội chợ' : ''}>{isCollapse && <i className="icon fas fa-campground" />}<IntlMessages id="sidebar.hoiCho" /></span>}
                      >
                        {(phongQLTM || qlHoiCho || bcHoiCho)
                          && (
                            <SubMenu key="bao-cao/hoi-cho" title={<span title="Báo cáo hội chợ">Báo cáo</span>}>
                              <MenuItem key="danh-muc/hoi-cho/quan-ly-hoi-cho">
                                <Link
                                  title="Báo cáo quản lý hội chợ"
                                  to="/danh-muc/hoi-cho/quan-ly-hoi-cho"
                                >Quản lý hội chợ
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                        {(thongKeAll || phongQLTM || qlHoiCho || tkHoiCho)
                          && (
                            <SubMenu key="thong-ke/hoi-cho" title={<span title="Thống kê hội chợ">Thống kê</span>}>
                              <MenuItem key="thong-ke/hoi-cho">
                                <Link
                                  title="Thống kê hội chợ"
                                  to="/thong-ke/hoi-cho"
                                >Hội chợ
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }

                  {/** Thương mại điện tử */}
                  {(thongKeAll || phongQLTM || qlTmdt || bcTmdt || tkTmdt)
                    && (
                      <SubMenu
                        key="thuong-mai-dien-tu"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Thương mại điện tử' : ''}>{isCollapse && <i className="icon fas fa-shopping-cart" />}<IntlMessages id="sidebar.tmdt" /></span>}
                      >
                        {(phongQLTM || qlTmdt || bcTmdt)
                          && (
                            <SubMenu key="bao-cao/bao-cao-thuong-mai-dien-tu" title={<span title="Báo cáo thương mại điện tử">Báo cáo</span>}>
                              <MenuItem key="bao-cao/bao-cao-thuong-mai-dien-tu/bao-cao-tmdt">
                                <Link
                                  title="Báo cáo quản lý thương mại điện tử"
                                  to="/bao-cao/bao-cao-thuong-mai-dien-tu/bao-cao-tmdt"
                                >Quản lý thương mại điện tử
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                        {(thongKeAll || phongQLTM || qlTmdt || tkTmdt)
                          && (
                            <SubMenu key="thong-ke/thuong-mai-dien-tu" title={<span title="Thống kê thương mại điện tử">Thống kê</span>}>
                              <MenuItem key="thong-ke/thuong-mai-dien-tu">
                                <Link
                                  title="Thống kê thương mại điện tử"
                                  to="/thong-ke/thuong-mai-dien-tu"
                                >Thương mại điện tử
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }

                  {/** Gas */}
                  {(thongKeAll || phongQLTM || qlGas || bcGas || tkCuaHangGas)
                    && (
                      <SubMenu
                        key="gas"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Gas' : ''}>{isCollapse && <i className="icon fas fa-burn" />}<IntlMessages id="sidebar.gas" /></span>}
                      >
                        {(phongQLTM || qlGas || bcGas)
                          && (
                            <SubMenu key="bao-cao/gas" title={<span title="Báo cáo gas (Huyện bc)">Báo cáo</span>}>
                              <MenuItem key="bao-cao/gas/bao-cao-gas">
                                <Link
                                  title="Báo cáo gas (Huyện bc)"
                                  to="/bao-cao/gas/bao-cao-gas"
                                >Báo cáo gas
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                        {(thongKeAll || phongQLTM || qlGas || tkCuaHangGas)
                          && (
                            <SubMenu key="thong-ke/gas" title={<span title="Thống kê gas">Thống kê</span>}>
                              <MenuItem key="thong-ke/cua-hang-gas">
                                <Link
                                  title="Thống kê cửa hàng gas"
                                  to="/thong-ke/cua-hang-gas"
                                >Cửa hàng kinh doanh gas
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                  {/** Doanh nghiệp bán hàng đa cấp */}
                  {(thongKeAll || phongQLTM || qlDoanhNghiepDaCap || bcDoanhNghiepDaCap || tkDoanhNghiepDaCap)
                    && (
                      <SubMenu
                        key="doanh-nghiep"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Doanh nghiệp bán hàng đa cấp' : ''}>{isCollapse && <i className="icon fas fa-user-tie" />}<IntlMessages id="sidebar.dnBanHangDaCap" /></span>}
                      >
                        {(phongQLTM || qlDoanhNghiepDaCap || bcDoanhNghiepDaCap)
                          && (
                            <SubMenu key="bao-cao/doanh-nghiep" title={<span title="Báo cáo doanh nghiệp bán hàng đa cấp">Báo cáo</span>}>
                              <MenuItem key="danh-muc/quan-ly-doanh-nghiep/doanh-nghiep">
                                <Link
                                  title="Báo cáo quản lý doanh nghiệp bán hàng đa cấp"
                                  to="/danh-muc/quan-ly-doanh-nghiep/doanh-nghiep"
                                >Quản lý doanh nghiệp bán hàng đa cấp
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                        {(thongKeAll || phongQLTM || qlDoanhNghiepDaCap || tkDoanhNghiepDaCap)
                          && (
                            <SubMenu key="thong-ke/doanh-nghiep-da-cap" title={<span title="Thống kê doanh nghiệp bán hàng đa cấp">Thống kê</span>}>
                              <MenuItem key="thong-ke/doanh-nghiep-da-cap">
                                <Link
                                  title="Thống kê doanh nghiệp bán hàng đa cấp"
                                  to="/thong-ke/doanh-nghiep-da-cap"
                                >Doanh nghiệp bán hàng đa cấp (theo biểu mẫu)
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                  {/** Hợp đồng theo mẫu */}
                  {(thongKeAll || phongQLTM || qlHopDongTheoMau || bcHopDongTheoMau || tkHopDongTheoMau)
                    && (
                      <SubMenu
                        key="hop-dong-theo-mau"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Hợp đồng theo mẫu' : ''}>{isCollapse && <i className="icon fas fa-file-alt" />}<IntlMessages id="sidebar.hdTheoMau" /></span>}
                      >
                        {(phongQLTM || qlHopDongTheoMau || bcHopDongTheoMau)
                          && (
                            <SubMenu key="danh-muc/quan-ly-doanh-nghiep/doanh-nghiep-dang-ky-hop-dong-thuong-mai" title={<span title="Báo cáo hợp đồng theo mẫu">Báo cáo</span>}>
                              <MenuItem key="danh-muc/quan-ly-doanh-nghiep/doanh-nghiep-dang-ky-hop-dong-thuong-mai">
                                <Link
                                  title="Báo cáo quản lý hợp đồng theo mẫu"
                                  to="/danh-muc/quan-ly-doanh-nghiep/doanh-nghiep-dang-ky-hop-dong-thuong-mai"
                                >Quản lý hợp đồng theo mẫu
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                        {(thongKeAll || phongQLTM || qlHopDongTheoMau || tkHopDongTheoMau)
                          && (
                            <SubMenu key="thong-ke/doanh-nghiep-dang-ky-hop-dong-thuong-mai" title={<span title="Thống kê hợp đồng theo mẫu">Thống kê</span>}>
                              <MenuItem key="thong-ke/doanh-nghiep-dang-ky-hop-dong-thuong-mai">
                                <Link
                                  title="Thống kê hợp đồng theo mẫu"
                                  to="/thong-ke/doanh-nghiep-dang-ky-hop-dong-thuong-mai"
                                >Hợp đồng theo mẫu (Theo biểu mẫu)
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }

                  {/** Đăng ký dấu nghiệp vụ */}
                  {(thongKeAll || phongQLTM || qlDangKyDau || bcDangKyDau || tkDangKyDau)
                    && (
                      <SubMenu
                        key="dang-ky-dau"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Đăng ký dấu nghiệp vụ' : ''}>{isCollapse && <i className="icon fas fa-stamp" />}<IntlMessages id="sidebar.dangKyDauNghiepVu" /></span>}
                      >
                        {(phongQLTM || qlDangKyDau || bcDangKyDau)
                          && (
                            <SubMenu key="danh-muc/quan-ly-doanh-nghiep/doanh-nghiep-dang-ky-dau" title={<span title="Báo cáo đăng ký dấu nghiệp vụ">Báo cáo</span>}>
                              <MenuItem key="danh-muc/quan-ly-doanh-nghiep/doanh-nghiep-dang-ky-dau">
                                <Link
                                  title="Báo cáo đăng ký dấu nghiệp vụ"
                                  to="/danh-muc/quan-ly-doanh-nghiep/doanh-nghiep-dang-ky-dau"
                                >Đăng ký dấu nghiệp vụ
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                        {(thongKeAll || phongQLTM || qlDangKyDau || tkDangKyDau)
                          && (
                            <SubMenu key="thong-ke/doanh-nghiep-danh-dau" title={<span title="Thống kê đăng ký dấu nghiệp vụ">Thống kê</span>}>
                              <MenuItem key="thong-ke/doanh-nghiep-danh-dau">
                                <Link
                                  title="Thống kê đăng ký dấu nghiệp vụ"
                                  to="/thong-ke/doanh-nghiep-danh-dau"
                                >Đăng ký dấu nghiệp vụ (Theo biểu mẫu)
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }

                  {/** Quản lý đăng ký khuyến mại */}
                  {(phongQLTM || qlDangKyKhuyenMai || bcDangKyKhuyenMai)
                    && (
                      <SubMenu
                        key="quan-ly-dang-ky-khuyen-mai"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Đăng ký khuyến mại' : ''}>{isCollapse && <i className="icon fas fa-file-alt" />}<IntlMessages id="sidebar.dkkhuyenmai" /></span>}
                      >
                        {(phongQLTM || qlDangKyKhuyenMai || bcDangKyKhuyenMai)
                          && (
                            <SubMenu key="bao-cao/quan-ly-dang-ky-khuyen-mai/dang-ky-khuyen-mai" title={<span title="Báo cáo đăng ký khuyến mại">Báo cáo</span>}>
                              <MenuItem key="bao-cao/quan-ly-dang-ky-khuyen-mai/dang-ky-khuyen-mai">
                                <Link
                                  title="Báo cáo đăng ký khuyến mại"
                                  to="/bao-cao/quan-ly-dang-ky-khuyen-mai/dang-ky-khuyen-mai"
                                >Đăng ký khuyến mại
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                  {/** Quản lý biểu mẫu khác */}
                  {(phongQLTM || qlBieuMauKhac || bcTongMucBanLeHangHoa || bcTieuChiCshttmNongThon)
                    && (
                      <SubMenu
                        key="quan-ly-bieu-mau-khac"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Biểu mẫu khác' : ''}>{isCollapse && <i className="icon fa fa-file" />}<IntlMessages id="sidebar.qlBieuMauKhac" /></span>}
                      >
                        {(phongQLTM || qlBieuMauKhac || bcTongMucBanLeHangHoa || bcTieuChiCshttmNongThon)
                          && (
                            <SubMenu key="bao-cao/bieu-mau-khac" title={<span title="Báo cáo biểu mẫu khác">Báo cáo</span>}>
                              {(phongQLTM || qlBieuMauKhac || bcTongMucBanLeHangHoa)
                                && (
                                  <MenuItem key="bao-cao/bieu-mau-khac/tong-muc-ban-le-hang-hoa">
                                    <Link
                                      title="Báo cáo tổng mức bán lẻ hàng hóa"
                                      to="/bao-cao/bieu-mau-khac/tong-muc-ban-le-hang-hoa"
                                    >Tổng mức bán lẻ hàng hóa
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(phongQLTM || qlBieuMauKhac || bcTieuChiCshttmNongThon)
                                && (
                                  <MenuItem key="bao-cao/bieu-mau-khac/tieu-chi-csht-thuong-mai-nong-thon">
                                    <Link
                                      title="Báo cáo tiêu chí cơ sở hạ tầng nông thôn"
                                      to="/bao-cao/bieu-mau-khac/tieu-chi-csht-thuong-mai-nong-thon"
                                    >Tiêu chí CSHT thương mại nông thôn
                                    </Link>
                                  </MenuItem>
                                )
                              }
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                </Menu>
              )
            }
            {/* QUẢN LÝ CÔNG NGHIỆP */}
            {
              type === Permission.P_QLCN
              && (
                thongKeAll
                || phongQLCN
                || qlCumCNDA || dmCumCN || dmCoSoHaTang || dmDuAn || bcCCN || bcDuAn || tkThdtKcht || tkDuAn
                || qlKhuyenCong || bcKhuyenCong || bcKhuyenCongDP || bcKhuyenCongUT || bcKqHoTro || bcUocTinhThucHien
                || qlKCN || dmQLKCN || dmKcn || dmDuAnDauTu || bcKCN || tkKhuCongNghiep
                || qlSanPhamCn || bcMotSoSpcnChuYeu || bcChiSoSanXuatCn || bcKqBinhChonSpcnTieuBieu
                || qlLinhVucKhoangSan || dmLinhVucKhoangSan
              )
              && (
                <Menu
                  className="submenu-parent"
                  defaultOpenKeys={!isCollapse ? ['san-pham-cong-nghiep', 'cum-cong-nghiep', 'khu-cong-nghiep', 'khuyen-cong', 'linh-vuc-khoang-san'] : []}
                  mode="inline"
                  selectedKeys={[newSelectedKeys]}
                  // inlineCollapsed
                  theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
                >
                  {/** Cụm công nghiệp – Dự án */}
                  {(thongKeAll || phongQLCN || qlCumCNDA || dmCumCN || dmCoSoHaTang || dmDuAn || bcCCN || bcDuAn || tkThdtKcht || tkDuAn)
                    && (
                      <SubMenu
                        key="cum-cong-nghiep"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Cụm công nghiệp - Dự án' : ''}>{isCollapse && <i className="icon fas fa-industry" />}<IntlMessages id="sidebar.cumCNDA" /></span>}
                      >
                        {(phongQLCN || qlCumCNDA || dmCumCN || dmCoSoHaTang || dmDuAn)
                          && (
                            <SubMenu key="danh-muc/danh-muc-cum-cong-nghiep" title={<span title="Danh mục cụm công nghiệp - dự án">Danh mục</span>}>
                              {(phongQLCN || qlCumCNDA || dmCumCN)
                                && (
                                  <MenuItem key="danh-muc/danh-muc-cum-cong-nghiep/cum-cong-nghiep">
                                    <Link
                                      title="Danh mục cụm công nghiệp"
                                      to="/danh-muc/danh-muc-cum-cong-nghiep/cum-cong-nghiep"
                                    >Cụm công nghiệp
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(phongQLCN || qlCumCNDA || dmCoSoHaTang)
                                && (
                                  <MenuItem key="danh-muc/danh-muc-cum-cong-nghiep/co-so-ha-tang">
                                    <Link
                                      title="Danh mục cơ sở hạ tầng"
                                      to="/danh-muc/danh-muc-cum-cong-nghiep/co-so-ha-tang"
                                    >Cơ sở hạ tầng
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(phongQLCN || qlCumCNDA || dmDuAn)
                                && (
                                  <MenuItem key="danh-muc/danh-muc-cum-cong-nghiep/du-an">
                                    <Link
                                      title="Danh mục dự án"
                                      to="/danh-muc/danh-muc-cum-cong-nghiep/du-an"
                                    >Dự án
                                    </Link>
                                  </MenuItem>
                                )
                              }
                            </SubMenu>
                          )
                        }
                        {(phongQLCN || qlCumCNDA || bcCCN || bcDuAn)
                          && (
                            <SubMenu key="bao-cao/bao-cao-cum-cn" title={<span title="Báo cáo cụm công nghiệp - dự án">Báo cáo</span>}>
                              {(phongQLCN || qlCumCNDA || bcCCN)
                                && (
                                  <MenuItem key="bao-cao/bao-cao-cum-cn/bao-cao-ccn">
                                    <Link
                                      title="Báo cáo cụm công nghiệp (Huyện bc)"
                                      to="/bao-cao/bao-cao-cum-cn/bao-cao-ccn"
                                    >Báo cáo CCN
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(phongQLCN || qlCumCNDA || bcDuAn)
                                && (
                                  <MenuItem key="bao-cao/bao-cao-tinh-hinh-dau-tu/bao-cao-du-an">
                                    <Link
                                      title="Báo cáo dự án"
                                      to="/bao-cao/bao-cao-tinh-hinh-dau-tu/bao-cao-du-an"
                                    >Báo cáo dự án
                                    </Link>
                                  </MenuItem>
                                )
                              }
                            </SubMenu>
                          )
                        }
                        {(thongKeAll || phongQLCN || qlCumCNDA || tkThdtKcht || tkDuAn)
                          && (
                            <SubMenu key="thong-ke/tong-hop-dau-tu-ha-tang" title={<span title="Thống kê cụm công nghiệp - dự án">Thống kê</span>}>
                              {(phongQLCN || qlCumCNDA || tkThdtKcht)
                                && (
                                  <MenuItem key="thong-ke/tong-hop-dau-tu-ha-tang">
                                    <Link
                                      title="Thống kê tổng hợp THĐTXD kết cấu hạ tầng"
                                      to="/thong-ke/tong-hop-dau-tu-ha-tang"
                                    >Tổng hợp THĐTXD kết cấu hạ tầng
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(phongQLCN || qlCumCNDA || tkDuAn)
                                && (
                                  <MenuItem key="thong-ke/du-an">
                                    <Link
                                      title="Thống kê dự án"
                                      to="/thong-ke/du-an"
                                    >Thống kê dự án
                                    </Link>
                                  </MenuItem>
                                )
                              }
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                  {/** Quản lý KCN */}
                  {(thongKeAll || phongQLCN || qlKCN || dmQLKCN || dmKcn || dmDuAnDauTu || bcKCN || tkKhuCongNghiep)
                    && (
                      <SubMenu
                        key="khu-cong-nghiep"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Quản lý khu công nghiệp' : ''}>{isCollapse && <i className="icon fas fa-city" />}<IntlMessages id="sidebar.qlkcn" /></span>}
                      >
                        {(phongQLCN || qlKCN || dmQLKCN || dmKcn || dmDuAnDauTu)
                          && (
                            <SubMenu key="danh-muc/danh-muc-khu-cong-nghiep" title={<span title="Danh mục khu công nghiệp">Danh mục</span>}>
                              {(phongQLCN || qlKCN || dmQLKCN || dmKcn)
                                && (
                                  <MenuItem key="danh-muc/danh-muc-khu-cong-nghiep/khu-cong-nghiep">
                                    <Link
                                      title="Danh mục khu công nghiệp"
                                      to="/danh-muc/danh-muc-khu-cong-nghiep/khu-cong-nghiep"
                                    >Khu công nghiệp
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(phongQLCN || qlKCN || dmQLKCN || dmDuAnDauTu)
                                && (
                                  <MenuItem key="danh-muc/danh-muc-khu-cong-nghiep/du-an-dau-tu">
                                    <Link
                                      title="Danh mục các dự án đầu tư"
                                      to="/danh-muc/danh-muc-khu-cong-nghiep/du-an-dau-tu"
                                    >Dự án đầu tư
                                    </Link>
                                  </MenuItem>
                                )}
                            </SubMenu>
                          )
                        }
                        {(phongQLCN || qlKCN || bcKCN)
                          && (
                            <SubMenu key="bao-cao/khu-cong-nghiep/bao-cao-khu-cong-nghiep" title={<span title="Báo cáo khu công nghiệp (Huyện bc)">Báo cáo</span>}>
                              <MenuItem key="bao-cao/khu-cong-nghiep/bao-cao-khu-cong-nghiep">
                                <Link
                                  title="Báo cáo khu công nghiệp (Huyện bc)"
                                  to="/bao-cao/khu-cong-nghiep/bao-cao-khu-cong-nghiep"
                                >Khu công nghiệp
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                        {/* {(thongKeAll || phongQLCN || qlKCN || tkKhuCongNghiep) &&
                      <SubMenu key="thong-ke/quan-ly-khu-cong-nghiep" title={<span title='Thống kê khu công nghiệp'>Thống kê</span>}>
                        <MenuItem key="thong-ke/khu-cong-nghiep">
                          <Link
                            to="/thong-ke/khu-cong-nghiep"
                            title='Thống kê khu công nghiệp'
                          >Khu công nghiệp </Link>
                        </MenuItem>
                      </SubMenu>
                    } */}
                      </SubMenu>
                    )
                  }
                  {/** Khuyến công */}
                  {(thongKeAll || phongQLCN || qlKhuyenCong || bcKhuyenCong || bcKhuyenCongDP || bcKhuyenCongUT || bcKqHoTro || bcUocTinhThucHien)
                    && (
                      <SubMenu
                        key="khuyen-cong"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Khuyến công' : ''}>{isCollapse && <i className="icon fas fa-sort-amount-up" />}<IntlMessages id="sidebar.khuyenCong" /></span>}
                      >
                        {(thongKeAll || phongQLCN || qlKhuyenCong || bcKhuyenCong || bcKhuyenCongDP || bcKhuyenCongUT || bcKqHoTro || bcUocTinhThucHien)
                          && (
                            <SubMenu key="bao-cao/khuyen-cong" title={<span title="Báo cáo khuyến công">Báo cáo</span>}>
                              {(thongKeAll || phongQLCN || qlKhuyenCong || bcKhuyenCong || bcKqHoTro)
                                // Kết quả hổ trợ
                                && (
                                  <MenuItem key="bao-cao/khuyen-cong/ket-qua-ho-tro">
                                    <Link
                                      title="Kết quả hỗ trợ từ nguồn vốn khuyến công 9 tháng đầu năm (Huyện bc)"
                                      to="/bao-cao/khuyen-cong/ket-qua-ho-tro"
                                    >Biểu 1
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(thongKeAll || phongQLCN || qlKhuyenCong || bcKhuyenCong || bcKhuyenCongDP)
                                // Khuyến công địa phương
                                && (
                                  <MenuItem key="bao-cao/khuyen-cong/khuyen-cong-dia-phuong">
                                    <Link
                                      title="Kinh phí khuyến công địa phương (Huyện bc)"
                                      to="/bao-cao/khuyen-cong/khuyen-cong-dia-phuong"
                                    >Biểu 2
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(thongKeAll || phongQLCN || qlKhuyenCong || bcKhuyenCong || bcUocTinhThucHien)
                                // Ước tính thực hiện
                                && (
                                  <MenuItem key="bao-cao/khuyen-cong/uoc-tinh-thuc-hien">
                                    <Link
                                      title="Báo cáo ước tính thực hiện kế hoạch kinh phí khuyến công (Huyện bc)"
                                      to="/bao-cao/khuyen-cong/uoc-tinh-thuc-hien"
                                    >Biểu 3
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(thongKeAll || phongQLCN || qlKhuyenCong || bcKhuyenCong || bcKhuyenCongUT)
                                // Khuyến công ước tính
                                && (
                                  <MenuItem key="bao-cao/khuyen-cong/khuyen-cong-uoc-tinh">
                                    <Link
                                      title="Báo cáo ước tính kết quả thực hiện kế hoạch khuyến công (Huyện bc)"
                                      to="/bao-cao/khuyen-cong/khuyen-cong-uoc-tinh"
                                    >Biểu 4
                                    </Link>
                                  </MenuItem>
                                )
                              }
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                  {/** Sản phẩm công nghiệp */}
                  {(thongKeAll || phongQLCN || qlSanPhamCn || bcMotSoSpcnChuYeu || bcChiSoSanXuatCn || bcKqBinhChonSpcnTieuBieu)
                    && (
                      <SubMenu
                        key="san-pham-cong-nghiep"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Sản phẩm công nghiệp' : ''}>{isCollapse && <i className="icon fa fa-archive" />}<IntlMessages id="sidebar.sanPhamCongNghiep" /></span>}
                      >
                        {(thongKeAll || phongQLCN || qlSanPhamCn || bcMotSoSpcnChuYeu || bcChiSoSanXuatCn || bcKqBinhChonSpcnTieuBieu)
                          && (
                            <SubMenu key="bao-cao/san-pham-cong-nghiep" title={<span title="Báo cáo sản phẩm công nghiệp">Báo cáo</span>}>
                              {(thongKeAll || phongQLCN || qlSanPhamCn || bcMotSoSpcnChuYeu)
                                && (
                                  <MenuItem key="bao-cao/san-pham-cong-nghiep/mot-so-san-pham-cn-chu-yeu">
                                    <Link
                                      title="Một số sản phẩm CN chủ yếu"
                                      to="/bao-cao/san-pham-cong-nghiep/mot-so-san-pham-cn-chu-yeu"
                                    >Một số sản phẩm CN chủ yếu
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(thongKeAll || phongQLCN || qlSanPhamCn || bcChiSoSanXuatCn)
                                && (
                                  <MenuItem key="bao-cao/san-pham-cong-nghiep/chi-so-san-xuat-cn">
                                    <Link
                                      title="Chỉ số sản xuất công nghiệp"
                                      to="/bao-cao/san-pham-cong-nghiep/chi-so-san-xuat-cn"
                                    >Chỉ số sản xuất công nghiệp
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(thongKeAll || phongQLCN || qlSanPhamCn || bcKqBinhChonSpcnTieuBieu)
                                && (
                                  <MenuItem key="bao-cao/san-pham-cong-nghiep/ket-qua-binh-chon-spcn-tieu-bieu">
                                    <Link
                                      title="Kết quả bình chọn sản phẩm CN tiêu biểu"
                                      to="/bao-cao/san-pham-cong-nghiep/ket-qua-binh-chon-spcn-tieu-bieu"
                                    >Kết quả bình chọn sản phẩm CN tiêu biểu
                                    </Link>
                                  </MenuItem>
                                )
                              }
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                  {/** Lĩnh vực khoáng sản*/}
                  {(thongKeAll || phongQLCN || qlLinhVucKhoangSan || dmLinhVucKhoangSan)
                    && (
                      <SubMenu
                        key="linh-vuc-khoang-san"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Lĩnh vực khoáng sản' : ''}>{isCollapse && <i className="icon fa fa-binoculars" />}<IntlMessages id="sidebar.linhVucKhoangSan" /></span>}
                      >
                        {(thongKeAll || phongQLCN || qlLinhVucKhoangSan || dmLinhVucKhoangSan)
                          && (
                            <SubMenu key="danh-muc/ql-linh-vuc-khoang-san" title={<span title="Lĩnh vực khoáng sản">Danh mục</span>}>
                              {(thongKeAll || phongQLCN || qlLinhVucKhoangSan || dmLinhVucKhoangSan)
                                && (
                                  <MenuItem key="danh-muc/ql-linh-vuc-khoang-san/linh-vuc-khoang-san">
                                    <Link
                                      title="Quản lý lĩnh vực khoáng sản"
                                      to="/danh-muc/ql-linh-vuc-khoang-san/linh-vuc-khoang-san"
                                    >Quản lý lĩnh vực khoáng sản
                                    </Link>
                                  </MenuItem>
                                )
                              }
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                </Menu>
              )
            }
            {/** KỸ THUẬT AN TOÀN MÔI TRƯỜNG */}
            {
              type === Permission.P_KTATMT
              && (
                thongKeAll
                || phongKTATMT
                || qlVLN || dmDoanhNghiep || dmLoaiHinhHD || bcVLN || tkCapPhepVLN
                || qlHoaChat || dmCoSoSuDungHoaChat || bcLoaiHC || bcSuCoHC || bcThanhTraHC || tkLoaiHC || tkSuCoHC || tkThanhTraHC || thanhTra
                || qlCongBoHopQuy || dmTheoDoiCongBoHopQuy
              )
              && (
                <Menu
                  className="submenu-parent"
                  defaultOpenKeys={!isCollapse ? ['vat-lieu-no-cong-nghiep', 'hoa-chat', 'cong-bo-hop-quy'] : []}
                  mode="inline"
                  selectedKeys={[newSelectedKeys]}
                  theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
                >
                  {/** Vật liệu nổ CN */}
                  {(thongKeAll || phongKTATMT || qlVLN || dmDoanhNghiep || dmLoaiHinhHD || bcVLN || tkCapPhepVLN || thanhTra)
                    && (
                      <SubMenu
                        key="vat-lieu-no-cong-nghiep"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Vật liêu nổ công nghiệp' : ''}>{isCollapse && <i className="icon fab fa-sith" />}<IntlMessages id="sidebar.vlncn" /></span>}
                      >
                        {(phongKTATMT || qlVLN || dmDoanhNghiep || dmLoaiHinhHD)
                          && (
                            <SubMenu key="danh-muc/vat-lieu-no-cong-nghiep" title={<span title="Danh mục vật liệu nổ công nghiệp">Danh mục</span>}>
                              {(phongKTATMT || qlVLN || dmDoanhNghiep)
                                && (
                                  <MenuItem key="danh-muc/vat-lieu-no-cong-nghiep/doanh-nghiep">
                                    <Link
                                      title="Danh mục doanh nghiệp vật liệu nổ công nghiệp"
                                      to="/danh-muc/vat-lieu-no-cong-nghiep/doanh-nghiep"
                                    >Doanh nghiệp
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(phongKTATMT || qlVLN || dmLoaiHinhHD)
                                && (
                                  <MenuItem key="danh-muc/vat-lieu-no-cong-nghiep/loai-hinh-hd">
                                    <Link
                                      title="Danh mục loại hình hoạt động vật liệu nổ công nghiệp"
                                      to="/danh-muc/vat-lieu-no-cong-nghiep/loai-hinh-hd"
                                    >Loại hình hoạt động
                                    </Link>
                                  </MenuItem>
                                )
                              }
                            </SubMenu>
                          )
                        }
                        {(phongKTATMT || qlVLN || bcVLN || thanhTra)
                          && (
                            <SubMenu key="bao-cao/vat-lieu-no-cong-nghiep" title={<span title="Báo cáo vật liệu nổ công nghiệp">Báo cáo</span>}>
                              <MenuItem key="danh-muc/vat-lieu-no-cong-nghiep/cap-phep-vat-lieu-no-cong-nghiep">
                                <Link
                                  title="Báo cáo cấp phép vật liệu nổ công nghiệp"
                                  to="/danh-muc/vat-lieu-no-cong-nghiep/cap-phep-vat-lieu-no-cong-nghiep"
                                >Cấp phép vật liệu nổ công nghiệp
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                        {(thongKeAll || phongKTATMT || qlVLN || tkCapPhepVLN)
                          && (
                            <SubMenu key="thong-ke/cap-giay-phep-vlncn" title={<span title="Thống kê vật liệu nổ công nghiệp">Thống kê</span>}>
                              <MenuItem key="thong-ke/cap-giay-phep-vlncn">
                                <Link
                                  title="Thống kê cấp phép vật liệu nổ công nghiệp"
                                  to="/thong-ke/cap-giay-phep-vlncn"
                                >Cấp phép vật liệu nổ công nghiệp
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                  {/** Hóa chất */}
                  {(thongKeAll || phongKTATMT || qlHoaChat || dmCoSoSuDungHoaChat || bcLoaiHC || bcSuCoHC || bcThanhTraHC || tkLoaiHC || tkSuCoHC || tkThanhTraHC || thanhTra)
                    && (
                      <SubMenu
                        key="hoa-chat"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Hóa chất' : ''}>{isCollapse && <i className="icon fas fa-vial" />}<IntlMessages id="sidebar.hoaChat" /></span>}
                      >
                        {(phongKTATMT || qlHoaChat || dmCoSoSuDungHoaChat || bcLoaiHC || bcSuCoHC || bcThanhTraHC || thanhTra)
                          && (
                            <SubMenu key="bao-cao/hoa-chat" title={<span title="Báo cáo hóa chất">Báo cáo</span>}>
                              {(phongKTATMT || qlHoaChat || dmCoSoSuDungHoaChat || thanhTra)
                                && (
                                  <MenuItem key="danh-muc/hoa-chat/co-so-su-dung-hoa-chat">
                                    <Link
                                      title="Báo cáo cơ sở hóa chất"
                                      to="/danh-muc/hoa-chat/co-so-su-dung-hoa-chat"
                                    >Cơ sở hóa chất
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(phongKTATMT || qlHoaChat || bcLoaiHC)
                                && (
                                  <MenuItem key="danh-muc/hoa-chat/loai-hoa-chat">
                                    <Link
                                      title="Báo cáo loại hóa chất"
                                      to="/danh-muc/hoa-chat/loai-hoa-chat"
                                    >Loại hóa chất
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(phongKTATMT || qlHoaChat || bcSuCoHC)
                                && (
                                  <MenuItem key="danh-muc/hoa-chat/tinh-hinh-su-co-hoa-chat">
                                    <Link
                                      title="Báo cáo sự cố hóa chất"
                                      to="/danh-muc/hoa-chat/tinh-hinh-su-co-hoa-chat"
                                    >Sự cố hóa chất
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(phongKTATMT || qlHoaChat || bcThanhTraHC)
                                && (
                                  <MenuItem key="danh-muc/hoa-chat/tinh-hinh-thanh-tra-kiem-tra">
                                    <Link
                                      title="Báo cáo thanh tra hóa chất"
                                      to="/danh-muc/hoa-chat/tinh-hinh-thanh-tra-kiem-tra"
                                    >Thanh tra hóa chất
                                    </Link>
                                  </MenuItem>
                                )
                              }
                            </SubMenu>
                          )
                        }

                        {(thongKeAll || phongKTATMT || qlHoaChat || tkLoaiHC || tkSuCoHC || tkThanhTraHC)
                          && (
                            <SubMenu key="thong-ke/hoa-chat" title={<span title="Thống kê hóa chất">Thống kê</span>}>
                              {(thongKeAll || phongKTATMT || qlHoaChat || tkLoaiHC)
                                && (
                                  <MenuItem key="thong-ke/loai-hoa-chat">
                                    <Link
                                      title="Thống kê loại hóa chất"
                                      to="/thong-ke/loai-hoa-chat"
                                    >Loại hóa chất
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(thongKeAll || phongKTATMT || qlHoaChat || tkSuCoHC)
                                && (
                                  <MenuItem key="thong-ke/tinh-hinh-su-co-hoa-chat">
                                    <Link
                                      title="Thống kê sự cố hóa chất"
                                      to="/thong-ke/tinh-hinh-su-co-hoa-chat"
                                    >Sự cố hóa chất
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(thongKeAll || phongKTATMT || qlHoaChat || tkThanhTraHC)
                                && (
                                  <MenuItem key="thong-ke/tinh-hinh-thanh-tra">
                                    <Link
                                      title="Thống kê thanh tra hóa chất"
                                      to="/thong-ke/tinh-hinh-thanh-tra"
                                    >Thanh tra hóa chất
                                    </Link>
                                  </MenuItem>
                                )
                              }
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }

                  {/** Công bố hợp quy */}
                  {(thongKeAll || phongKTATMT || qlCongBoHopQuy || dmTheoDoiCongBoHopQuy || dmDoanhNghiepCongBoHopQuy)
                    && (
                      <SubMenu
                        key="cong-bo-hop-quy"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Công bố hợp quy' : ''}>{isCollapse && <i className="icon fas fa-vial" />}<IntlMessages id="sidebar.congBoHopQuy" /></span>}
                      >
                        {(thongKeAll || phongKTATMT || qlCongBoHopQuy || dmTheoDoiCongBoHopQuy || dmDoanhNghiepCongBoHopQuy)
                          && (
                            <SubMenu key="danh-muc/cong-bo-hop-quy" title={<span title="Danh mục công bố hợp quy">Danh mục</span>}>
                              {(phongKTATMT || qlCongBoHopQuy || dmDoanhNghiepCongBoHopQuy)
                                && (
                                  <MenuItem key="danh-muc/cong-bo-hop-quy/doanh-nghiep-cong-bo-hop-quy">
                                    <Link
                                      title="Danh mục doanh nghiệp công bố hợp quy"
                                      to="/danh-muc/cong-bo-hop-quy/doanh-nghiep-cong-bo-hop-quy"
                                    >Doanh nghiệp
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(phongKTATMT || qlCongBoHopQuy || dmTheoDoiCongBoHopQuy)
                                && (
                                  <MenuItem key="danh-muc/cong-bo-hop-quy/theo-doi-cong-bo-hop-quy">
                                    <Link
                                      title="Theo dõi công bố hợp quy"
                                      to="/danh-muc/cong-bo-hop-quy/theo-doi-cong-bo-hop-quy"
                                    >Theo dõi công bố hợp quy
                                    </Link>
                                  </MenuItem>
                                )
                              }
                            </SubMenu>


                          )
                        }
                      </SubMenu>
                    )
                  }
                </Menu>
              )
            }
            {/** QUẢN LÝ NĂNG LƯỢNG */}
            {
              type === Permission.P_QLNL
              && (
                thongKeAll
                || phongQLNL
                || qlThuyDien || dmThuyDien
                || qlTramBa || dmTba || dmTba110 || dmTba220 || dmTba500
                || qlCapDien || bcCapDien || tkCapDien
                || qlQuyTrinhVanHanh
                || khSuDungNlTrongDiem || dmKhSuDungNlTrongDiem
                || qlNLTaiTaoVaNLKhac || dmDuAnNLTaiTaoVaNLKhac
                || qlCapPhepHoatDongDienLuc || dmCapPhepHoatDongDienLuc
                || thanhTra
              )
              && (
                <Menu
                  className="submenu-parent"
                  defaultOpenKeys={!isCollapse ? ['thuy-dien', 'tram-bien-ap', 'cap-dien', 'cap-phep-hoat-dong-dien-luc', 'nang-luong-tai-tao-va-nang-luong-khac', 'su-sung-nang-luong-trong-diem'] : []}
                  mode="inline"
                  selectedKeys={[newSelectedKeys]}
                  // inlineCollapsed
                  theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
                >
                  {/** Thủy điện */}
                  {(thongKeAll || phongQLNL || qlThuyDien || dmThuyDien)
                    && (
                      <SubMenu
                        key="thuy-dien"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Thủy điện' : ''}>{isCollapse && <i className="icon fas fa-bolt" />}<IntlMessages id="sidebar.thuyDien" /></span>}
                      >
                        {(phongQLNL || qlThuyDien || dmThuyDien)
                          && (
                            <SubMenu key="/danh-muc/thuy-dien" title={<span title="Danh mục thủy điện">Danh mục</span>}>
                              <MenuItem key="danh-muc/thuy-dien/thuy-dien-bac-thang">
                                <Link
                                  title="Danh mục thủy điện bậc thang"
                                  to="/danh-muc/thuy-dien/thuy-dien-bac-thang"
                                >Thủy điện bậc thang
                                </Link>
                              </MenuItem>
                              <MenuItem key="danh-muc/thuy-dien/thuy-dien-vua-va-nho">
                                <Link
                                  title="Danh mục thủy điện vừa và nhỏ"
                                  to="/danh-muc/thuy-dien/thuy-dien-vua-va-nho"
                                >Thủy điện vừa và nhỏ
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                        {/** Báo cáo Thủy điện 2020*/}
                        {(phongQLNL || qlThuyDien || bcThuyDien)
                          && (
                            <SubMenu key="/bao-cao/thuy-dien" title={<span title="Báo cáo">Báo cáo</span>}>
                              <MenuItem key="bao-cao/thuy-dien/hien-trang-an-toan-ho-chua-dap-thuy-dien">
                                <Link
                                  title="Hiện trạng an toàn đập, hồ chứa thủy điện"
                                  to="/bao-cao/thuy-dien/hien-trang-an-toan-ho-chua-dap-thuy-dien"
                                >Hiện trạng an toàn đập, hồ chứa
                                </Link>
                              </MenuItem>
                              <MenuItem key="bao-cao/thuy-dien/danh-gia-an-toan-ho-chua-dap-thuy-dien">
                                <Link
                                  title="Đánh giá an toàn đập, hồ chứa thủy điện"
                                  to="/bao-cao/thuy-dien/danh-gia-an-toan-ho-chua-dap-thuy-dien"
                                >Đánh giá an toàn đập, hồ chứa
                                </Link>
                              </MenuItem>
                              <MenuItem key="bao-cao/thuy-dien/cong-tac-qlnc-ve-ql-ho-chua-dap-thuy-dien">
                                <Link
                                  title="Công tác quản lý nhà nước về quản lý an toàn đập, hồ chứa, thủy điện"
                                  to="/bao-cao/thuy-dien/cong-tac-qlnc-ve-ql-ho-chua-dap-thuy-dien"
                                >Công tác QLNN về QL an toàn
                                </Link>
                              </MenuItem>
                              <MenuItem className="QTI-menu-sidebar-wrap" key="bao-cao/thuy-dien/hien-trang-an-toan-ho-chua-dap-thuy-dien-tren-dia-ban-tinh">
                                <Link
                                  title="Thông tin năng lượng"
                                  to="/bao-cao/thuy-dien/hien-trang-an-toan-ho-chua-dap-thuy-dien-tren-dia-ban-tinh"
                                >Thông tin năng lượng
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                        {/** Quy trình vận hành hồ chứa */}
                        {(phongQLNL || qlThuyDien || qlQuyTrinhVanHanh)
                          && (
                            <SubMenu key="/bao-cao/quy-trinh-van-hanh" title={<span title="Quy trình vận hành">Quy trình vận hành hồ chứa</span>}>
                              <MenuItem className="QTI-menu-sidebar-wrap" key="bao-cao/quy-trinh-van-hanh/luu-vuc-song">
                                <Link
                                  title="Thủy điện lưu vực sông Vu Gia - Thu Bồn"
                                  to="/bao-cao/quy-trinh-van-hanh/luu-vuc-song"
                                >Thủy điện lưu vực sông Vu Gia - Thu Bồn
                                </Link>
                              </MenuItem>
                              <MenuItem key="bao-cao/quy-trinh-van-hanh/thuy-dien-bac-thang">
                                <Link
                                  title="Thủy điện bậc thang"
                                  to="/bao-cao/quy-trinh-van-hanh/thuy-dien-bac-thang"
                                >Thủy điện bậc thang
                                </Link>
                              </MenuItem>
                              <MenuItem key="bao-cao/quy-trinh-van-hanh/thuy-dien-vua-va-nho">
                                <Link
                                  title="Thủy điện vừa và nhỏ"
                                  to="/bao-cao/quy-trinh-van-hanh/thuy-dien-vua-va-nho"
                                >Thủy điện vừa và nhỏ
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                  {/** Trạm biến áp */}
                  {(phongQLNL || qlTramBa || dmTba110 || dmTba220 || dmTba500)
                    && (
                      <SubMenu
                        key="tram-bien-ap"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Trạm biến áp' : ''}>{isCollapse && <i className="icon fas fa-charging-station" />}<IntlMessages id="sidebar.tramBienAp" /></span>}
                      >
                        {(phongQLNL || qlTramBa || dmTba110 || dmTba220 || dmTba500)
                          && (
                            <SubMenu key="danh-muc/danh-muc-tram-bien-ap" title={<span title="Danh mục Trạm biến áp">Trạm biến áp</span>}>
                              {(phongQLNL || qlTramBa || dmTba110)
                                && (
                                  <MenuItem key="danh-muc/danh-muc-tram-bien-ap/tram-bien-ap-110">
                                    <Link
                                      title="Danh mục Trạm biến áp 110"
                                      to="/danh-muc/danh-muc-tram-bien-ap/tram-bien-ap-110/110"
                                    >Trạm biến áp 110kV
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(phongQLNL || qlTramBa || dmTba220)
                                && (
                                  <MenuItem key="danh-muc/danh-muc-tram-bien-ap/tram-bien-ap-220">
                                    <Link
                                      title="Danh mục Trạm biến áp 220"
                                      to="/danh-muc/danh-muc-tram-bien-ap/tram-bien-ap-220/220"
                                    >Trạm biến áp 220kV
                                    </Link>
                                  </MenuItem>
                                )
                              }
                              {(phongQLNL || qlTramBa || dmTba500)
                                && (
                                  <MenuItem key="danh-muc/danh-muc-tram-bien-ap/tram-bien-ap-500">
                                    <Link
                                      title="Danh mục Trạm biến áp 500"
                                      to="/danh-muc/danh-muc-tram-bien-ap/tram-bien-ap-500/500"
                                    >Trạm biến áp 500kV
                                    </Link>
                                  </MenuItem>
                                )
                              }
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                  {/** Cấp điện */}
                  {(thongKeAll || phongQLNL || qlCapDien || bcCapDien || tkCapDien)
                    && (
                      <SubMenu
                        key="cap-dien"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Cấp điện' : ''}>{isCollapse && <i className="icon fas fa-bolt" />}<IntlMessages id="sidebar.capDien" /></span>}
                      >
                        {(phongQLNL || qlCapDien || bcCapDien)
                          && (
                            <SubMenu key="/bao-cao/cap-dien" title={<span title="Báo cáo cấp điện">Báo cáo</span>}>
                              <MenuItem key="bao-cao/cap-dien/cap-dien">
                                <Link
                                  title="Báo cáo cấp điện"
                                  to="/bao-cao/cap-dien/cap-dien"
                                >Cấp điện
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                  {/** Cấp phép hoạt động điện lực*/}
                  {(thongKeAll || phongQLNL || qlCapPhepHoatDongDienLuc || dmCapPhepHoatDongDienLuc || thanhTra)
                    && (
                      <SubMenu
                        key="cap-phep-hoat-dong-dien-luc"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Cấp phép hoạt động điện lực' : ''}>{isCollapse && <i className="icon fas fa-bolt" />}<IntlMessages id="sidebar.capPhepHDDienLuc" /></span>}
                      >
                        {(phongQLNL || qlCapPhepHoatDongDienLuc || dmCapPhepHoatDongDienLuc || thanhTra)
                          && (
                            <SubMenu key="/danh-muc/cap-phep-hoat-dong-dien-luc" title={<span title="Danh mục cấp phép hoạt động điện lực">Danh mục</span>}>
                              <MenuItem key="danh-muc/cap-phep-hoat-dong-dien-luc/cap-phep-hoat-dong-dien-luc">
                                <Link
                                  title="Danh mục cấp phép hoạt động điện lực"
                                  to="/danh-muc/cap-phep-hoat-dong-dien-luc/cap-phep-hoat-dong-dien-luc"
                                >Cấp phép hoạt động điện lực
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                  {/** Năng lượng tái tạo và năng lượng khác */}
                  {(thongKeAll || phongQLNL || qlNLTaiTaoVaNLKhac || dmDuAnNLTaiTaoVaNLKhac)
                    && (
                      <SubMenu
                        key="nang-luong-tai-tao-va-nang-luong-khac"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Năng lượng tái tạo và năng lượng khác' : 'Năng lượng tái tạo và năng lượng khác'}>{isCollapse && <i className="icon fas fa-bolt" />}<IntlMessages id="sidebar.nangLuongTaiTao" /></span>}
                      >
                        {(phongQLNL || qlNLTaiTaoVaNLKhac || dmDuAnNLTaiTaoVaNLKhac)
                          && (
                            <SubMenu key="/danh-muc/nang-luong-tai-tao-va-nang-luong-khac" title={<span title="Danh mục">Danh mục</span>}>
                              <MenuItem className="QTI-menu-sidebar-wrap" key="danh-muc/nang-luong-tai-tao-va-nang-luong-khac/du-an-nang-luong-tai-tao-va-nang-luong-khac">
                                <Link
                                  title="Danh mục dự án năng lượng tái tạo và năng lượng khác"
                                  to="/danh-muc/nang-luong-tai-tao-va-nang-luong-khac/du-an-nang-luong-tai-tao-va-nang-luong-khac"
                                > Dự án năng lượng tái tạo và năng lượng khác
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                  {/** Khách hàng sử dụng năng lượng trong điểm */}
                  {(phongQLNL || khSuDungNlTrongDiem || dmKhSuDungNlTrongDiem)
                    && (
                      <SubMenu
                        key="su-sung-nang-luong-trong-diem"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Khách hàng sử dụng năng lượng trong điểm' : 'Khách hàng sử dụng năng lượng trong điểm'}>{isCollapse && <i className="icon fas fa-bolt" />}<IntlMessages id="sidebar.sudunnangluong" /></span>}
                      >
                        {(phongQLNL || khSuDungNlTrongDiem || dmKhSuDungNlTrongDiem)
                          && (
                            <SubMenu key="/danh-muc/khach-hang-su-dung-nang-luong-trong-diem/don-vi-su-dung-nang-luong-trong-diem" title={<span title="Danh mục khách hàng sử dụng năng lượng trọng điểm">Danh mục</span>}>
                              <MenuItem className="QTI-menu-sidebar-wrap" key="danh-muc/khach-hang-su-dung-nang-luong-trong-diem/don-vi-su-dung-nang-luong-trong-diem">
                                <Link
                                  title="Danh mục đơn vị sử dụng năng lượng trọng điểm"
                                  to="/danh-muc/khach-hang-su-dung-nang-luong-trong-diem/don-vi-su-dung-nang-luong-trong-diem"
                                >Danh mục đơn vị sử dụng năng lượng trọng điểm
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                </Menu>
              )
            }
            {/** QUẢN LÝ THỊ TRƯỜNG */}
            {
              type === Permission.P_QLTT
              && (
                thongKeAll
                || pQltt
                || qlThiTruong || bcCtqlThiTruong
              )
              && (
                <Menu
                  className="submenu-parent"
                  defaultOpenKeys={!isCollapse ? ['thi-truong'] : []}
                  mode="inline"
                  selectedKeys={[newSelectedKeys]}
                  // inlineCollapsed
                  theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
                >
                  {/** Quản lý thị trường */}
                  {(thongKeAll || pQltt || qlThiTruong || bcCtqlThiTruong)
                    && (
                      <SubMenu
                        key="thi-truong"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Quản lý thị trường' : ''}>{isCollapse && <i className="icon fa fa-chart-area" />}<IntlMessages id="sidebar.qlThiTruong" /></span>}
                      >
                        {(pQltt || qlThiTruong || bcCtqlThiTruong)
                          && (
                            <SubMenu key="/bao-cao/quan-ly-thi-truong/cong-tac-quan-ly-thi-truong" title={<span title="Báo cáo">Báo cáo</span>}>
                              <MenuItem key="bao-cao/quan-ly-thi-truong/cong-tac-quan-ly-thi-truong">
                                <Link
                                  title="Công tác quản lý thị trường"
                                  to="/bao-cao/quan-ly-thi-truong/cong-tac-quan-ly-thi-truong"
                                >Công tác quản lý thị trường
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                </Menu>
              )
            }
            {/** QUẢN LÝ XUẤT NHẬP KHẨU */}
            {
              type === Permission.P_QLDT
              && (
                thongKeAll
                || pQldt
                || qlXuatNhapKhau || bcKimNgachXnk
              )
              && (
                <Menu
                  className="submenu-parent"
                  defaultOpenKeys={!isCollapse ? ['xuat-nhap-khau'] : []}
                  mode="inline"
                  selectedKeys={[newSelectedKeys]}
                  // inlineCollapsed
                  theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
                >
                  {/** Thủy điện */}
                  {(thongKeAll || pQldt || qlXuatNhapKhau || bcKimNgachXnk)
                    && (
                      <SubMenu
                        key="xuat-nhap-khau"
                        className={this.getNavStyleSubMenuClass(navStyle)}
                        title={<span className="wrap-icon-sidebar" title={isCollapse ? 'Xuất nhập khẩu' : ''}>{isCollapse && <i className="icon fa fa-exchange-alt" />}<IntlMessages id="sidebar.qlDauTu" /></span>}
                      >
                        {(pQldt || qlXuatNhapKhau || bcKimNgachXnk)
                          && (
                            <SubMenu key="/bao-cao/xuat-nhap-khau/kim-ngach-xuat-nhap-khau" title={<span title="Báo cáo xuất nhập khẩu">Báo cáo</span>}>
                              <MenuItem key="bao-cao/xuat-nhap-khau/kim-ngach-xuat-nhap-khau">
                                <Link
                                  title="Báo cáo kim ngạch xuất nhập khẩu"
                                  to="/bao-cao/xuat-nhap-khau/kim-ngach-xuat-nhap-khau"
                                >Kim ngạch xuất nhập khẩu
                                </Link>
                              </MenuItem>
                            </SubMenu>
                          )
                        }
                      </SubMenu>
                    )
                  }
                </Menu>
              )
            }
          </CustomScrollbars>
        </div>
      </Auxiliary >
    );
  }
}

SidebarContent.propTypes = {
  themeType: PropTypes.string.isRequired,
  pathname: PropTypes.string.isRequired,
  navStyle: PropTypes.string.isRequired,
  activedVaiTro: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapStateToProps = ({ settings, auth }) => {
  const {
    navStyle, themeType, locale, pathname
  } = settings;
  return {
    navStyle, themeType, locale, pathname, auth
  };
};
export default connect(mapStateToProps)(SidebarContent);
